import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import {MatTableDataSource, MatPaginator, MatSort,} from '@angular/material';
import * as $ from 'jquery';

var COMP = environment.component.capacity;
export interface Element {
    column1: string;
    column2: string;
    column3: string;
    column4: string;
    column5: string;
    column6: string;
    column7: string;
    column8: string;
  }

  const ELEMENT_DATA: Element[] = [
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.3",
      column6: "No",
      column7: "Accountability   Inclusion, participation, equity and empowerment – Enabling environment: Extent to which societal changes are integrated into government's inclusion, participation, equity and empowerment policies and mechanisms.",
      column8: "Formulate Policies and Strategies:\nDo authorities have the capacity to ensure decentralization and encourage involvement of interested parties throughout the process of developing policies and strategies?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.4",
      column6: "No",
      column7: "Accountability   Inclusion, participation, equity and empowerment – Organizational level: Availability of information.",
      column8: "Evaluate:\nDoes the organization have the capacity to ensure availability and accessibility of communication and feedback mechanisms for employees, customers and other key stakeholders to be heard?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.4",
      column6: "No",
      column7: "Accountability   Inclusion, participation, equity and empowerment – Organizational level: Degree to which management seeks suggestions and collects ideas for improvement.",
      column8: "Evaluate:\nDoes the organization have the capacity to ensure availability and accessibility of communication and feedback mechanisms for employees, customers and other key stakeholders to be heard?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.2",
      column6: "No",
      column7: "Accountability   Organizational level: Accountability of managers for the corruption / inadequate performance of their subordinates.",
      column8: "Evaluate:\nDoes the organization have the capacity to develop and manage accountability mechanisms for evaluation?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.2",
      column6: "No",
      column7: "Accountability   Organizational level: Alignment of mutual accountability programme with government‘s mission, priorities and managerial capacities.",
      column8: "Budget, Manage and Implement:\nDoes the organization have the capacity to develop, manage and enforce accountability mechanisms regarding programme budgeting, management and implementation?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.2",
      column6: "No",
      column7: "Accountability   Organizational level: Clarity and awareness of mutual accountability goals and priorities among leaders.",
      column8: "Budget, Manage and Implement:\nDoes the organization have the capacity to develop, manage and enforce accountability mechanisms regarding programme budgeting, management and implementation?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.2",
      column6: "No",
      column7: "Accountability   Organizational level: Degree of enforcement of mutual accountability mechanisms.",
      column8: "Budget, Manage and Implement:\nDoes the organization have the capacity to develop, manage and enforce accountability mechanisms regarding programme budgeting, management and implementation?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.2",
      column6: "No",
      column7: "Accountability   Organizational level: Effectiveness of organizational oversight, access to resource functions (e.g., ombudsman).  \n  Receptivity to and action taken on recommendations of external auditors.",
      column8: "Evaluate:\nDoes the organization have the capacity to develop and manage accountability mechanisms for evaluation?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.2",
      column6: "No",
      column7: "Accountability   Organizational level: Existence and effectiveness of dialogue mechanisms (and other links as appropriate) between the organization and relevant domestic and external stakeholders to discuss formulation and implementation of the organization's accountability mechanisms.",
      column8: "Engage Stakeholders:\nDoes the organization have the capacity to develop accountability mechanisms that ensure multi stakeholder participation?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.2",
      column6: "No",
      column7: "Accountability   Organizational level: Existence of ‗customer charters‘ (or similar undertakings) that establish the obligations of service providers and the rights of users.",
      column8: "Engage Stakeholders:\nDoes the organization have the capacity to develop accountability mechanisms that ensure multi stakeholder participation?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.2",
      column6: "No",
      column7: "Accountability   Organizational level: Existence of clear and well understood policies, procedures and other mechanisms: \n  Conflict of interest policies, which serve as an effective barrier to members of management from using their positions for personal benefit or interfering in day to day administration. \n  Complaint mechanisms (whistleblower protection), and staff has confidence in them.\n  Other 'watch dog' functions.",
      column8: "Evaluate:\nDoes the organization have the capacity to develop and manage accountability mechanisms for evaluation?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.2",
      column6: "No",
      column7: "Accountability   Organizational level: Existence of continuing efforts to streamline bureaucracy rendering it more open, efficient and user friendly for the public.",
      column8: "Budget, Manage and Implement:\nDoes the organization have the capacity to develop, manage and enforce accountability mechanisms regarding programme budgeting, management and implementation?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.2",
      column6: "No",
      column7: "Accountability   Organizational level: Existence of mechanism (e.g., law, convention) to oblige decision makers to give reasons for their decisions.",
      column8: "Budget, Manage and Implement:\nDoes the organization have the capacity to develop, manage and enforce accountability mechanisms regarding programme budgeting, management and implementation?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.2",
      column6: "No",
      column7: "Accountability   Organizational level: Existence of organizational structures of accountability to clients and constituents.",
      column8: "Formulate Policies and Strategies:\nDoes the organization have the capacity to develop and manage accountability mechanisms to ensure formulation of clear and transparent policies and strategies?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.2",
      column6: "No",
      column7: "Accountability   Organizational level: Extent to which societal changes are integrated into the organization's mutual accountability mechanisms.",
      column8: "Budget, Manage and Implement:\nDoes the organization have the capacity to develop, manage and enforce accountability mechanisms regarding programme budgeting, management and implementation?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.2",
      column6: "No",
      column7: "Accountability   Organizational level: Level of citizen/customer satisfaction (e.g., with the performance of the organization).",
      column8: "Evaluate:\nDoes the organization have the capacity to develop and manage accountability mechanisms for evaluation?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.2",
      column6: "No",
      column7: "Accountability   Organizational level: Level of opportunity among employees to express their views to management.",
      column8: "Engage Stakeholders:\nDoes the organization have the capacity to develop accountability mechanisms that ensure multi stakeholder participation?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.2",
      column6: "No",
      column7: "Accountability   Organizational level: Quality (e.g., transparent, participatory, engaged, respective) and frequency of dialogue between the organization and domestic and external stakeholders.",
      column8: "Engage Stakeholders:\nDoes the organization have the capacity to develop accountability mechanisms that ensure multi stakeholder participation?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.2",
      column6: "No",
      column7: "Accountability   Organizational level: Quality of action taken as a result of critical events‘ analysis of opportunities and threats of most significance to the organization‘s mutual accountability mechanisms.",
      column8: "Assess a Situation and Define Vision and Mandate: Does the organization have the capacity to frame, manage and interpret a comprehensive analysis of the accountability mechanism environment? \nDoes the organization have the capacity to create a vision for robust accountability mechanisms?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.2",
      column6: "No",
      column7: "Accountability   Organizational level: Quality of analysis of environmental influences (at the appropriate level, e.g., market, sector) and their relative degree of impact.",
      column8: "Assess a Situation and Define Vision and Mandate: Does the organization have the capacity to frame, manage and interpret a comprehensive analysis of the accountability mechanism environment? \nDoes the organization have the capacity to create a vision for robust accountability mechanisms?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.2",
      column6: "No",
      column7: "Accountability   Organizational level: Quality of mechanisms that ensure mutual accountability.",
      column8: "Formulate Policies and Strategies:\nDoes the organization have the capacity to develop and manage accountability mechanisms to ensure formulation of clear and transparent policies and strategies?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.2",
      column6: "No",
      column7: "Accountability   Organizational level: Transparency and accessibility of gift and hospitality registers to the public.",
      column8: "Evaluate:\nDoes the organization have the capacity to develop and manage accountability mechanisms for evaluation?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.3",
      column6: "No",
      column7: "Institutional Arrangements   Financial management   Enabling environment:  Existence of long term strategic policy options for financial resource management.",
      column8: "Formulate Policies and Strategies: Do authorities have the capacity to develop financial policies and plans that support achievement of MDG targets in a cost effective and sustainable manner?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.3",
      column6: "No",
      column7: "Institutional Arrangements   Financial management   Enabling environment: Alignment of financial resources and planning budgets (including credit, where appropriate).",
      column8: "Budget, Manage and Implement: Do authorities have the capacity to manage financial resources appropriately in the implementation of programmes and delivery of services?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.3",
      column6: "No",
      column7: "Institutional Arrangements   Financial management   Enabling environment: Extent to which societal changes are integrated into Government's financial resource management policies and mechanisms.",
      column8: "Formulate Policies and Strategies: Do authorities have the capacity to develop financial policies and plans that support achievement of MDG targets in a cost effective and sustainable manner?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "2.1",
      column6: "No",
      column7: "Leadership   Enabling environment: Ability of authorities to effectively represent the government (national or local) to external interests.",
      column8: "Engage Stakeholders:\nDo authorities have the capacity to manage relations with domestic and external stakeholders inclusively and constructively?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "2.1",
      column6: "No",
      column7: "Leadership   Enabling environment: Actionability of objectives and outputs in national and local development strategies.",
      column8: "Formulate Policies and Strategies:\nDo authorities have the capacity to develop integrated policies and plans linked to resources?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "2.1",
      column6: "No",
      column7: "Leadership   Enabling environment: Clarity of leadership philosophy to domestic and external stakeholders.",
      column8: "Engage Stakeholders:\nDo authorities have the capacity to manage relations with domestic and external stakeholders inclusively and constructively?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "2.1",
      column6: "No",
      column7: "Leadership   Enabling environment: Existence and effectiveness of dialogue mechanisms (and other links as appropriate) among domestic institutions.",
      column8: "Engage Stakeholders:\nDo authorities have the capacity to manage relations with domestic and external stakeholders inclusively and constructively?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "2.1",
      column6: "No",
      column7: "Leadership   Enabling environment: Existence of influential and outspoken champions for ownership and capacity development.",
      column8: "Engage Stakeholders:\nDo authorities have the capacity to manage relations with domestic and external stakeholders inclusively and constructively?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "2.1",
      column6: "No",
      column7: "Leadership   Enabling environment: Existence of long term strategic policy choices for capacity development.",
      column8: "Formulate Policies and Strategies:\nDo authorities have the capacity to develop integrated policies and plans linked to resources?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "2.1",
      column6: "No",
      column7: "Leadership   Enabling environment: Extent to which societal changes are integrated into governmental functioning.",
      column8: "Formulate Policies and Strategies:\nDo authorities have the capacity to develop integrated policies and plans linked to resources?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "2.1",
      column6: "No",
      column7: "Leadership   Enabling environment: External image of the government (national or local) (e.g., image is consistent with goals and objectives).",
      column8: "Engage Stakeholders:\nDo authorities have the capacity to manage relations with domestic and external stakeholders inclusively and constructively?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "2.1",
      column6: "No",
      column7: "Leadership   Enabling environment: Government ownership of policies, goals and structure.",
      column8: "Engage Stakeholders:\nDo authorities have the capacity to manage relations with domestic and external stakeholders inclusively and constructively?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "2.1",
      column6: "No",
      column7: "Leadership   Enabling environment: Quality (e.g., transparent, participatory, engaged, respective) and frequency of dialogue between and among domestic and external stakeholders.",
      column8: "Engage Stakeholders:\nDo authorities have the capacity to manage relations with domestic and external stakeholders inclusively and constructively?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "2.1",
      column6: "No",
      column7: "Leadership   Enabling environment: Quality of analysis of environmental influences (at the appropriate level, e.g., market, sector) and their relative degree of impact.",
      column8: "Assess a Situation and Define Vision and Mandate:\nDo authorities have the capacity to frame, manage and interpret analysis of internal and external dynamics (at the appropriate level, e.g., market, sector)? \nDo authorities have the capacity to conduct long term visioning?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.5",
      column6: "No",
      column7: "Accountability   Access to information – Enabling environment: Alignment of access to information and knowledge programme with government‘s mission, priorities and managerial capacities.",
      column8: "Budget, Manage and Implement:\nDo authorities have the capacity to ensure access to information and knowledge to support the process of budgeting, management and implementation of programmes and delivery of services?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.5",
      column6: "No",
      column7: "Accountability   Access to information – Enabling environment: Amount and quality of information available; transparency of information.",
      column8: "Evaluate: Do authorities have the capacity to ensure, through evaluation mechanisms, citizens' access to information and knowledge?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.5",
      column6: "No",
      column7: "Accountability   Access to information – Enabling environment: Availability of public information in local dialects for dissemination to local users.",
      column8: "Engage Stakeholders:\nDo authorities have the capacity to engage stakeholders throughout the process of developing plans for access to information and knowledge?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.5",
      column6: "No",
      column7: "Accountability   Access to information – Enabling environment: Clarity and awareness of access to information and knowledge goals and priorities among leaders.",
      column8: "Budget, Manage and Implement:\nDo authorities have the capacity to ensure access to information and knowledge to support the process of budgeting, management and implementation of programmes and delivery of services?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.5",
      column6: "No",
      column7: "Accountability   Access to information – Enabling environment: Credibility of the media. Quality of the media (e.g., publication of stories critical of the administration, quoting opposition politicians.",
      column8: "Evaluate: Do authorities have the capacity to ensure, through evaluation mechanisms, citizens' access to information and knowledge?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.5",
      column6: "No",
      column7: "Accountability   Access to information – Enabling environment: Degree of citizen/customer access to budget allocation information regarding local services, e.g., schools, clinics.",
      column8: "Evaluate: Do authorities have the capacity to ensure, through evaluation mechanisms, citizens' access to information and knowledge?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.5",
      column6: "No",
      column7: "Accountability   Access to information – Enabling environment: Degree of citizen/customer access to global knowledge (e.g., connectivity, internet access points).",
      column8: "Evaluate: Do authorities have the capacity to ensure, through evaluation mechanisms, citizens' access to information and knowledge?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.5",
      column6: "No",
      column7: "Accountability   Access to information – Enabling environment: Degree of effort aimed at administrative simplification (e.g., use of simple language).",
      column8: "Engage Stakeholders:\nDo authorities have the capacity to engage stakeholders throughout the process of developing plans for access to information and knowledge?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.5",
      column6: "No",
      column7: "Accountability   Access to information – Enabling environment: Degree of enforcement of access to information and knowledge mechanisms.",
      column8: "Budget, Manage and Implement:\nDo authorities have the capacity to ensure access to information and knowledge to support the process of budgeting, management and implementation of programmes and delivery of services?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.5",
      column6: "No",
      column7: "Accountability   Access to information – Enabling environment: Degree to which information is shared across organizations",
      column8: "Budget, Manage and Implement:\nDo authorities have the capacity to ensure access to information and knowledge to support the process of budgeting, management and implementation of programmes and delivery of services?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.5",
      column6: "Yes",
      column7: "Accountability   Access to information – Enabling environment: Degree, quality and enforcement of mechanisms that ensure access to information and knowledge (e.g., constitutional recognition of freedom of information; state policy on public access to information in all governmental branches and units, promoting transparency in public transactions and access to public records).",
      column8: "Formulate Policies and Strategies:\nDo authorities have the capacity to ensure access to and provision of information and knowledge throughout the process of developing policies and strategies?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.5",
      column6: "No",
      column7: "Accountability   Access to information – Enabling environment: Equity of distribution of public resources, infrastructure and facilities enabling nationwide access to information.",
      column8: "Evaluate: Do authorities have the capacity to ensure, through evaluation mechanisms, citizens' access to information and knowledge?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.5",
      column6: "No",
      column7: "Accountability   Access to information – Enabling environment: Existence and effectiveness of dialogue mechanisms (and other links as appropriate) between and among the government and domestic and external stakeholders on issues relating to access to information and knowledge.",
      column8: "Engage Stakeholders:\nDo authorities have the capacity to engage stakeholders throughout the process of developing plans for access to information and knowledge?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.5",
      column6: "No",
      column7: "Accountability   Access to information – Enabling environment: Existence and enforcement of anti monopoly laws.",
      column8: "Evaluate: Do authorities have the capacity to ensure, through evaluation mechanisms, citizens' access to information and knowledge?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.5",
      column6: "No",
      column7: "Accountability   Access to information – Enabling environment: Existence of freedom of information laws and/or procedures to ensure that members of the public can obtain information/documents from public authorities.",
      column8: "Formulate Policies and Strategies:\nDo authorities have the capacity to ensure access to and provision of information and knowledge throughout the process of developing policies and strategies?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.5",
      column6: "Yes",
      column7: "Accountability   Access to information – Enabling environment: Existence of long term strategic policy options for access to information and knowledge.",
      column8: "Formulate Policies and Strategies:\nDo authorities have the capacity to ensure access to and provision of information and knowledge throughout the process of developing policies and strategies?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.5",
      column6: "No",
      column7: "Accountability   Access to information – Enabling environment: Existence of system for generating internal and external feedback on effectiveness of information services.",
      column8: "Evaluate: Do authorities have the capacity to ensure, through evaluation mechanisms, citizens' access to information and knowledge?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.5",
      column6: "No",
      column7: "Accountability   Access to information – Enabling environment: Extent of efforts to improve availability, accuracy and transparency of information.",
      column8: "Budget, Manage and Implement:\nDo authorities have the capacity to ensure access to information and knowledge to support the process of budgeting, management and implementation of programmes and delivery of services?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.5",
      column6: "No",
      column7: "Accountability   Access to information – Enabling environment: Extent to which societal changes are integrated into Government's access to information and knowledge policies and mechanisms.",
      column8: "Formulate Policies and Strategies:\nDo authorities have the capacity to ensure access to and provision of information and knowledge throughout the process of developing policies and strategies?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.5",
      column6: "No",
      column7: "Accountability   Access to information – Enabling environment: Growth of independent media sector (including internet, informal journals, newsletters).",
      column8: "Evaluate: Do authorities have the capacity to ensure, through evaluation mechanisms, citizens' access to information and knowledge?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.5",
      column6: "No",
      column7: "Accountability   Access to information – Enabling environment: Independence of the media (from government control, influence).",
      column8: "Evaluate: Do authorities have the capacity to ensure, through evaluation mechanisms, citizens' access to information and knowledge?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.5",
      column6: "No",
      column7: "Accountability   Access to information – Enabling environment: Level of competition within the media (print, television, radio).",
      column8: "Evaluate: Do authorities have the capacity to ensure, through evaluation mechanisms, citizens' access to information and knowledge?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.5",
      column6: "No",
      column7: "Accountability   Access to information – Enabling environment: Media Censorship of the media (via an 'Official Secrets Act‘ or something similar; libel laws; journalist licensing laws).",
      column8: "Evaluate: Do authorities have the capacity to ensure, through evaluation mechanisms, citizens' access to information and knowledge?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.5",
      column6: "No",
      column7: "Accountability   Access to information – Enabling environment: Quality (e.g., transparent, participatory, engaged, respective) and frequency of dialogue between and among the government and domestic and external stakeholders.",
      column8: "Engage Stakeholders:\nDo authorities have the capacity to engage stakeholders throughout the process of developing plans for access to information and knowledge?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.5",
      column6: "No",
      column7: "Accountability   Access to information – Enabling environment: Quality of action taken as a result of 'critical events‘ analysis of opportunities and threats of most significance to the government‘s access to information and knowledge policies.",
      column8: "Assess a Situation and Define Vision and Mandate:\nDo authorities have the capacity to frame, manage and interpret a comprehensive situation analysis? \nDo authorities have the capacity to create a vision for equitable, broad and meaningful access to and provision of information and knowledge?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.5",
      column6: "No",
      column7: "Accountability   Access to information – Enabling environment: Quality of analysis of environmental influences (at the appropriate level, e.g., market, sector) and their relative degree of impact on policies relating to access to information and knowledge",
      column8: "Assess a Situation and Define Vision and Mandate:\nDo authorities have the capacity to frame, manage and interpret a comprehensive situation analysis? \nDo authorities have the capacity to create a vision for equitable, broad and meaningful access to and provision of information and knowledge?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.5",
      column6: "No",
      column7: "Accountability   Access to information – Enabling environment: Rights of foreign press relative to domestic press.",
      column8: "Evaluate: Do authorities have the capacity to ensure, through evaluation mechanisms, citizens' access to information and knowledge?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.5",
      column6: "No",
      column7: "Accountability   Access to information – Enabling environment: Transparency of non media business interests of media owners.",
      column8: "Evaluate: Do authorities have the capacity to ensure, through evaluation mechanisms, citizens' access to information and knowledge?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.6",
      column6: "No",
      column7: "Accountability   Access to information – Organizational level: Adequacy of personnel skills in electronic access to and management of information.",
      column8: "Budget, Manage and Implement:\nDoes the organization have the capacity to provide technological, communications and information resources and networks required for the development and delivery of programmes and services?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.6",
      column6: "No",
      column7: "Accountability   Access to information – Organizational level: Alignment of access to information and knowledge programme with the organization‘s mission, priorities and managerial capacities.",
      column8: "Budget, Manage and Implement:\nDoes the organization have the capacity to provide technological, communications and information resources and networks required for the development and delivery of programmes and services?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.6",
      column6: "No",
      column7: "Accountability   Access to information – Organizational level: Amount and quality of information available; transparency of information.",
      column8: "Evaluate:\nDoes the organization have the capacity to ensure, through evaluation mechanisms, access to information and knowledge for all stakeholders (e.g., employees, customers)?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.6",
      column6: "No",
      column7: "Accountability   Access to information – Organizational level: Availability of public information in local dialects for dissemination to local users.",
      column8: "Engage Stakeholders: \nDoes the organization have the capacity to enable a free flow of knowledge and information among partners and across networks?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.6",
      column6: "No",
      column7: "Accountability   Access to information – Organizational level: Clarity and awareness of access to information and knowledge goals and priorities among organizational leadership.",
      column8: "Budget, Manage and Implement:\nDoes the organization have the capacity to provide technological, communications and information resources and networks required for the development and delivery of programmes and services?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.6",
      column6: "No",
      column7: "Accountability   Access to information – Organizational level: Degree of customer access to organizational knowledge.",
      column8: "Evaluate:\nDoes the organization have the capacity to ensure, through evaluation mechanisms, access to information and knowledge for all stakeholders (e.g., employees, customers)?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.6",
      column6: "No",
      column7: "Accountability   Access to information – Organizational level: Degree of effort aimed at administrative simplification (e.g., use of simple language).",
      column8: "Engage Stakeholders: \nDoes the organization have the capacity to enable a free flow of knowledge and information among partners and across networks?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.6",
      column6: "No",
      column7: "Accountability   Access to information – Organizational level: Degree of enforcement of access to information and knowledge mechanisms.",
      column8: "Budget, Manage and Implement:\nDoes the organization have the capacity to provide technological, communications and information resources and networks required for the development and delivery of programmes and services?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.6",
      column6: "Yes",
      column7: "Accountability   Access to information – Organizational level: Degree, quality and enforcement of mechanisms that ensure access to information and knowledge.",
      column8: "Formulate Policies and Strategies:\nDoes the organization have the capacity to put in place a policy and blueprint (long term and strategic goals and plans) for information, knowledge and communications?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.6",
      column6: "No",
      column7: "Accountability   Access to information – Organizational level: Existence and effectiveness of dialogue mechanisms (and other links as appropriate) between the organization and relevant domestic and external stakeholders on issues relating to access to information and knowledge.",
      column8: "Engage Stakeholders: \nDoes the organization have the capacity to enable a free flow of knowledge and information among partners and across networks?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.6",
      column6: "No",
      column7: "Accountability   Access to information – Organizational level: Existence of long term strategic policy options for access to information and knowledge.",
      column8: "Formulate Policies and Strategies:\nDoes the organization have the capacity to put in place a policy and blueprint (long term and strategic goals and plans) for information, knowledge and communications?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.6",
      column6: "No",
      column7: "Accountability   Access to information – Organizational level: Existence of organizational information and knowledge management system covering content and content architecture, infrastructure, human resources, budgets and processes, including information and knowledge creation, storage/archiving, quality management, security and dissemination.",
      column8: "Budget, Manage and Implement:\nDoes the organization have the capacity to provide technological, communications and information resources and networks required for the development and delivery of programmes and services?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.6",
      column6: "No",
      column7: "Accountability   Access to information – Organizational level: Existence of organizational policy and blueprint for information, knowledge and communications.",
      column8: "Formulate Policies and Strategies:\nDoes the organization have the capacity to put in place a policy and blueprint (long term and strategic goals and plans) for information, knowledge and communications?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.6",
      column6: "No",
      column7: "Accountability   Access to information – Organizational level: Existence of system for generating internal and external feedback on effectiveness of information services.",
      column8: "Evaluate:\nDoes the organization have the capacity to ensure, through evaluation mechanisms, access to information and knowledge for all stakeholders (e.g., employees, customers)?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.6",
      column6: "No",
      column7: "Accountability   Access to information – Organizational level: Extent of efforts to improve availability, accuracy and transparency of information.",
      column8: "Budget, Manage and Implement:\nDoes the organization have the capacity to provide technological, communications and information resources and networks required for the development and delivery of programmes and services?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.6",
      column6: "No",
      column7: "Accountability   Access to information – Organizational level: Extent to which information is shared openly within the organization.",
      column8: "Budget, Manage and Implement:\nDoes the organization have the capacity to provide technological, communications and information resources and networks required for the development and delivery of programmes and services?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.6",
      column6: "No",
      column7: "Accountability   Access to information – Organizational level: Extent to which societal changes are integrated into the organization's access to information and knowledge policies and mechanisms.",
      column8: "Formulate Policies and Strategies:\nDoes the organization have the capacity to put in place a policy and blueprint (long term and strategic goals and plans) for information, knowledge and communications?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.6",
      column6: "No",
      column7: "Accountability   Access to information – Organizational level: Level of access to technological resources needed to operate efficiently.",
      column8: "Budget, Manage and Implement:\nDoes the organization have the capacity to provide technological, communications and information resources and networks required for the development and delivery of programmes and services?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.6",
      column6: "No",
      column7: "Accountability   Access to information – Organizational level: Quality (e.g., transparent, participatory, engaged, respective) and frequency of dialogue between the organization and domestic and external stakeholders.",
      column8: "Engage Stakeholders: \nDoes the organization have the capacity to enable a free flow of knowledge and information among partners and across networks?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.6",
      column6: "No",
      column7: "Accountability   Access to information – Organizational level: Quality of action taken as a result of critical events‘ analysis of opportunities and threats of most significance to the organization‘s access to information and knowledge policies.",
      column8: "Assess a Situation and Define Vision and Mandate:\nDoes the organization have the capacity to frame, manage and interpret a comprehensive situation analysis of the environment relating to access to and provision of information? \nDoes the organization have the capacity to create a vision for equitable, broad and meaningful access to information and knowledge?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.6",
      column6: "No",
      column7: "Accountability   Access to information – Organizational level: Quality of analysis of environmental influences (at the appropriate level, e.g., market, sector) and their relative degree of impact on policies relating to access to information and knowledge.",
      column8: "Assess a Situation and Define Vision and Mandate:\nDoes the organization have the capacity to frame, manage and interpret a comprehensive situation analysis of the environment relating to access to and provision of information? \nDoes the organization have the capacity to create a vision for equitable, broad and meaningful access to information and knowledge?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.6",
      column6: "No",
      column7: "Accountability   Access to information – Organizational level: Transparency of organizational policies and code of ethics in information management.",
      column8: "Formulate Policies and Strategies:\nDoes the organization have the capacity to put in place a policy and blueprint (long term and strategic goals and plans) for information, knowledge and communications?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.1",
      column6: "No",
      column7: "Accountability   Enabling environment: Accountability of managers for the corruption / inadequate performance of their subordinates.",
      column8: "Evaluate: Do authorities have the capacity to develop and manage accountability mechanisms for evaluation?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.1",
      column6: "No",
      column7: "Accountability   Enabling environment: Alignment of mutual accountability programme with government‘s mission, priorities and managerial capacities.",
      column8: "Budget, Manage and Implement:\nDo authorities have the capacity to develop, manage and enforce accountability mechanisms regarding programme budgeting, management and implementation?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.1",
      column6: "No",
      column7: "Accountability   Enabling environment: Clarity and awareness of mutual accountability goals and priorities among leaders.",
      column8: "Budget, Manage and Implement:\nDo authorities have the capacity to develop, manage and enforce accountability mechanisms regarding programme budgeting, management and implementation?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.1",
      column6: "No",
      column7: "Accountability   Enabling environment: Degree of enforcement of mutual accountability mechanisms.",
      column8: "Budget, Manage and Implement:\nDo authorities have the capacity to develop, manage and enforce accountability mechanisms regarding programme budgeting, management and implementation?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.1",
      column6: "No",
      column7: "Accountability   Enabling environment: Effectiveness of parliamentary oversight, access to resource functions (e.g., ombudsman).",
      column8: "Evaluate: Do authorities have the capacity to develop and manage accountability mechanisms for evaluation?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.1",
      column6: "No",
      column7: "Accountability   Enabling environment: Existence and effectiveness of dialogue mechanisms (and other links as appropriate) among domestic institutions.",
      column8: "Engage Stakeholders:\nDo authorities have the capacity to develop accountability mechanisms that ensure multi stakeholder participation?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.1",
      column6: "No",
      column7: "Accountability   Enabling environment: Existence of 'citizen charters' (or similar undertakings) that establish the obligations of service providers and the rights of users.",
      column8: "Engage Stakeholders:\nDo authorities have the capacity to develop accountability mechanisms that ensure multi stakeholder participation?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.1",
      column6: "No",
      column7: "Accountability   Enabling environment: Existence of clear and well understood laws, conventions, procedures and other mechanisms: \n□ Conflict of interest laws, which serve as an effective barrier to members of the executive and legislative branches using their positions for personal benefit or interfering in day to day administration. \n□ Election laws, barring convicted criminals from running for election. \n□ Procedures for monitoring the private interests (personal assets, lifestyle, and income) of elected officials and members of their immediate families are in place. \n□ Complaint mechanisms (whistleblower protection), and staff has confidence in them.\n□ Other societal 'watch dog' functions.",
      column8: "Evaluate: Do authorities have the capacity to develop and manage accountability mechanisms for evaluation?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.1",
      column6: "No",
      column7: "Accountability   Enabling environment: Existence of continuing efforts to streamline bureaucracy rendering it more open, efficient and user friendly for the public.",
      column8: "Budget, Manage and Implement:\nDo authorities have the capacity to develop, manage and enforce accountability mechanisms regarding programme budgeting, management and implementation?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.1",
      column6: "No",
      column7: "Accountability   Enabling environment: Existence of mechanism (e.g., law, convention) to oblige decision makers (e.g., members of the executive branch, civil servants) to give reasons for their decisions.",
      column8: "Budget, Manage and Implement:\nDo authorities have the capacity to develop, manage and enforce accountability mechanisms regarding programme budgeting, management and implementation?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.1",
      column6: "No",
      column7: "Accountability   Enabling environment: Existence of mechanisms to register the voice of citizens and their perceptions.",
      column8: "Evaluate: Do authorities have the capacity to develop and manage accountability mechanisms for evaluation?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.1",
      column6: "No",
      column7: "Accountability   Enabling environment: Extent to which societal changes are integrated into government's mutual accountability mechanisms.",
      column8: "Formulate Policies and Strategies:\nDo authorities have the capacity to develop and manage accountability mechanisms to ensure formulation of clear and transparent policies and strategies?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.1",
      column6: "No",
      column7: "Accountability   Enabling environment: Frequency of department client satisfaction surveys.",
      column8: "Evaluate: Do authorities have the capacity to develop and manage accountability mechanisms for evaluation?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.1",
      column6: "No",
      column7: "Accountability   Enabling environment: Frequency of rotation of employees in vulnerable positions so as to periodically change their physical / functional assignments.",
      column8: "Evaluate: Do authorities have the capacity to develop and manage accountability mechanisms for evaluation?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.1",
      column6: "No",
      column7: "Accountability   Enabling environment: Level of citizen/customer satisfaction.",
      column8: "Evaluate: Do authorities have the capacity to develop and manage accountability mechanisms for evaluation?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.1",
      column6: "No",
      column7: "Accountability   Enabling environment: Level of opportunity among legislators who oppose the government to express their views in the Legislature.",
      column8: "Engage Stakeholders:\nDo authorities have the capacity to develop accountability mechanisms that ensure multi stakeholder participation?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.1",
      column6: "No",
      column7: "Accountability   Enabling environment: Operational nature of select committees (e.g., they meet in public; their reports are made public; they make a practice of hearing submissions from members of the public and civil society organizations).",
      column8: "Engage Stakeholders:\nDo authorities have the capacity to develop accountability mechanisms that ensure multi stakeholder participation?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.1",
      column6: "No",
      column7: "Accountability   Enabling environment: Quality (e.g., open) and frequency of policy debates.",
      column8: "Engage Stakeholders:\nDo authorities have the capacity to develop accountability mechanisms that ensure multi stakeholder participation?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.1",
      column6: "No",
      column7: "Accountability   Enabling environment: Quality (e.g., transparent, participatory, engaged, respective) and frequency of dialogue between and among domestic and external stakeholders.",
      column8: "Engage Stakeholders:\nDo authorities have the capacity to develop accountability mechanisms that ensure multi stakeholder participation?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.1",
      column6: "No",
      column7: "Accountability   Enabling environment: Quality of action taken as a result of 'critical events‘ analysis of opportunities and threats of most significance to government‘s mutual accountability mechanisms.",
      column8: "Assess a Situation and Define Vision and Mandate:\nDo authorities have the capacity to frame, manage and interpret a comprehensive analysis of the accountability mechanism environment? \nDo authorities have the capacity to create a vision for robust accountability mechanisms?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.1",
      column6: "No",
      column7: "Accountability   Enabling environment: Quality of analysis of environmental influences (at the appropriate level, e.g., market, sector) and their relative degree of impact.",
      column8: "Assess a Situation and Define Vision and Mandate:\nDo authorities have the capacity to frame, manage and interpret a comprehensive analysis of the accountability mechanism environment? \nDo authorities have the capacity to create a vision for robust accountability mechanisms?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.1",
      column6: "No",
      column7: "Accountability   Enabling environment: Quality of mechanisms that ensure mutual accountability.",
      column8: "Formulate Policies and Strategies:\nDo authorities have the capacity to develop and manage accountability mechanisms to ensure formulation of clear and transparent policies and strategies?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.1",
      column6: "No",
      column7: "Accountability   Enabling environment: Readiness of the legislature to lift the immunity enjoyed by one of its members, regardless of the party to which the member belongs, when there are serious grounds for believing that he or she may be guilty of a serious criminal offence.",
      column8: "Evaluate: Do authorities have the capacity to develop and manage accountability mechanisms for evaluation?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.1",
      column6: "No",
      column7: "Accountability   Enabling environment: Receptivity to and action taken on recommendations of the Public Accounts Committee by the Executive: \n□ The Public Accounts Committee has power to call officials (including Ministers) for questioning. \n□ As a matter of practice or requirement, the chair of the Public Accounts Committee is chaired by a Member who is independent of the government of the day.",
      column8: "Evaluate: Do authorities have the capacity to develop and manage accountability mechanisms for evaluation?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.1",
      column6: "No",
      column7: "Accountability   Enabling environment: Transparency and accessibility of gift and hospitality registers to the public.",
      column8: "Evaluate: Do authorities have the capacity to develop and manage accountability mechanisms for evaluation?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.1",
      column6: "No",
      column7: "Accountability   Enabling environment: Transparency of identities of civil servants.",
      column8: "Evaluate: Do authorities have the capacity to develop and manage accountability mechanisms for evaluation?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.1",
      column6: "No",
      column7: "Accountability   Enabling environment: Transparency of methods used to sell government assets.",
      column8: "Budget, Manage and Implement:\nDo authorities have the capacity to develop, manage and enforce accountability mechanisms regarding programme budgeting, management and implementation?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.3",
      column6: "No",
      column7: "Accountability   Inclusion, participation, equity and empowerment – Enabling environment: Accessibility of government departments to the media.",
      column8: "Evaluate:\nDo authorities have the capacity to ensure availability and accessibility of communication and feedback mechanisms in both legislative and executive bodies for citizens to be heard?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.3",
      column6: "No",
      column7: "Accountability   Inclusion, participation, equity and empowerment – Enabling environment: Adequacy of avenues to ensure equitable/broad and meaningful participation in situation analyses.",
      column8: "Assess a Situation and Define Vision and Mandate:\nDo authorities have the capacity to frame, manage and interpret a comprehensive situation analysis? \nDo authorities have the capacity to create a vision for equitable, broad and meaningful public engagement?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.3",
      column6: "No",
      column7: "Accountability   Inclusion, participation, equity and empowerment – Enabling environment: Alignment of inclusion, participation, equity and empowerment programme with government‘s mission, priorities and managerial capacities.",
      column8: "Budget, Manage and Implement:\nDo authorities have the capacity to ensure public participation in the budgeting, management and implementation of programmes and delivery of services?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.3",
      column6: "No",
      column7: "Accountability   Inclusion, participation, equity and empowerment – Enabling environment: Availability of information.",
      column8: "Evaluate:\nDo authorities have the capacity to ensure availability and accessibility of communication and feedback mechanisms in both legislative and executive bodies for citizens to be heard?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.3",
      column6: "No",
      column7: "Accountability   Inclusion, participation, equity and empowerment – Enabling environment: Clarity and awareness of inclusion, participation, equity and empowerment goals and priorities among leaders.",
      column8: "Budget, Manage and Implement:\nDo authorities have the capacity to ensure public participation in the budgeting, management and implementation of programmes and delivery of services?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.3",
      column6: "No",
      column7: "Accountability   Inclusion, participation, equity and empowerment – Enabling environment: Degree of enforcement of inclusion, participation, equity and empowerment mechanisms.",
      column8: "Budget, Manage and Implement:\nDo authorities have the capacity to ensure public participation in the budgeting, management and implementation of programmes and delivery of services?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.3",
      column6: "No",
      column7: "Accountability   Inclusion, participation, equity and empowerment – Enabling environment: Degree of government support for effective functioning of CSO/CBOs.",
      column8: "Engage Stakeholders:\nDo authorities have the capacity to enable equitable and meaningful public participation throughout the process of creating national and/or local development plans?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.3",
      column6: "No",
      column7: "Accountability   Inclusion, participation, equity and empowerment – Enabling environment: Degree to which decentralization is political, functional (e.g., health and education at local government level is accessible to all) and fiscal/budgetary (e.g., revenues and allocation of resources for public expenditures).",
      column8: "Budget, Manage and Implement:\nDo authorities have the capacity to ensure public participation in the budgeting, management and implementation of programmes and delivery of services?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.3",
      column6: "No",
      column7: "Accountability   Inclusion, participation, equity and empowerment – Enabling environment: Degree to which leadership seeks suggestions and collects ideas for improvement.",
      column8: "Evaluate:\nDo authorities have the capacity to ensure availability and accessibility of communication and feedback mechanisms in both legislative and executive bodies for citizens to be heard?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.3",
      column6: "No",
      column7: "Accountability   Inclusion, participation, equity and empowerment – Enabling environment: Existence and effectiveness of dialogue mechanisms (and other links as appropriate) among the government, domestic and external stakeholders on issues relating to inclusion, participation, equity and empowerment.",
      column8: "Engage Stakeholders:\nDo authorities have the capacity to enable equitable and meaningful public participation throughout the process of creating national and/or local development plans?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.3",
      column6: "No",
      column7: "Accountability   Inclusion, participation, equity and empowerment – Enabling environment: Existence of clear and well understood inclusion and feedback mechanisms.",
      column8: "Evaluate:\nDo authorities have the capacity to ensure availability and accessibility of communication and feedback mechanisms in both legislative and executive bodies for citizens to be heard?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.3",
      column6: "No",
      column7: "Accountability   Inclusion, participation, equity and empowerment – Enabling environment: Existence of mechanisms to register the voice of customers and employees and their perceptions.",
      column8: "Evaluate:\nDo authorities have the capacity to ensure availability and accessibility of communication and feedback mechanisms in both legislative and executive bodies for citizens to be heard?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.3",
      column6: "No",
      column7: "Accountability   Inclusion, participation, equity and empowerment – Enabling environment: Existence of special and/or provisional measures to ensure partnerships with all excluded groups.",
      column8: "Engage Stakeholders:\nDo authorities have the capacity to enable equitable and meaningful public participation throughout the process of creating national and/or local development plans?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.3",
      column6: "No",
      column7: "Accountability   Inclusion, participation, equity and empowerment – Enabling environment: Frequency and effectiveness of periodic publicity campaigns (in local languages) explaining the procedures and criteria for administrative decisions or processes (e.g., granting permits, licenses, bank loans, building plots, assessing taxes).",
      column8: "Engage Stakeholders:\nDo authorities have the capacity to enable equitable and meaningful public participation throughout the process of creating national and/or local development plans?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.3",
      column6: "No",
      column7: "Accountability   Inclusion, participation, equity and empowerment – Enabling environment: Level of civic engagement and bottom up influence on the policy agenda and development.",
      column8: "Engage Stakeholders:\nDo authorities have the capacity to enable equitable and meaningful public participation throughout the process of creating national and/or local development plans?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.3",
      column6: "No",
      column7: "Accountability   Inclusion, participation, equity and empowerment – Enabling environment: Level of civic engagement and CSO/CBO activity.",
      column8: "Engage Stakeholders:\nDo authorities have the capacity to enable equitable and meaningful public participation throughout the process of creating national and/or local development plans?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.3",
      column6: "No",
      column7: "Accountability   Inclusion, participation, equity and empowerment – Enabling environment: Number and quality of citizen/customer suggestions received, recorded, acted upon.",
      column8: "Evaluate:\nDo authorities have the capacity to ensure availability and accessibility of communication and feedback mechanisms in both legislative and executive bodies for citizens to be heard?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.3",
      column6: "No",
      column7: "Accountability   Inclusion, participation, equity and empowerment – Enabling environment: Quality (e.g., transparent, participatory, engaged, respective) and frequency of dialogue between and among the government, domestic and external stakeholders.",
      column8: "Engage Stakeholders:\nDo authorities have the capacity to enable equitable and meaningful public participation throughout the process of creating national and/or local development plans?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.3",
      column6: "No",
      column7: "Accountability   Inclusion, participation, equity and empowerment – Enabling environment: Quality of action taken as a result of 'critical events' analysis of opportunities and threats of most significance to the government‘s policies relating to inclusion, participation, equity and empowerment.",
      column8: "Assess a Situation and Define Vision and Mandate:\nDo authorities have the capacity to frame, manage and interpret a comprehensive situation analysis? \nDo authorities have the capacity to create a vision for equitable, broad and meaningful public engagement?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.3",
      column6: "No",
      column7: "Accountability   Inclusion, participation, equity and empowerment – Enabling environment: Quality of analysis of environmental influences (at the appropriate level, e.g., market, sector) and their relative degree of impact on the government‘s policies relating to inclusion, participation, equity and empowerment.",
      column8: "Assess a Situation and Define Vision and Mandate:\nDo authorities have the capacity to frame, manage and interpret a comprehensive situation analysis? \nDo authorities have the capacity to create a vision for equitable, broad and meaningful public engagement?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.3",
      column6: "Yes",
      column7: "Accountability   Inclusion, participation, equity and empowerment – Enabling environment: Quality of mechanisms that ensure inclusion, participation, equity and empowerment.",
      column8: "Formulate Policies and Strategies:\nDo authorities have the capacity to ensure decentralization and encourage involvement of interested parties throughout the process of developing policies and strategies?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.4",
      column6: "No",
      column7: "Accountability   Inclusion, participation, equity and empowerment – Organizational level: Accessibility of organization‘s management to the media.",
      column8: "Evaluate:\nDoes the organization have the capacity to ensure availability and accessibility of communication and feedback mechanisms for employees, customers and other key stakeholders to be heard?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.4",
      column6: "No",
      column7: "Accountability   Inclusion, participation, equity and empowerment – Organizational level: Adequacy of avenues to ensure equitable/broad and meaningful participation in situation analyses.",
      column8: "Assess a Situation and Define Vision and Mandate:\nDoes the organization have the capacity to frame, manage and interpret a comprehensive situation analysis for broad and meaningful participation? \nDoes the organization have the capacity to create a vision for broad and meaningful participation?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.4",
      column6: "No",
      column7: "Accountability   Inclusion, participation, equity and empowerment – Organizational level: Alignment of inclusion, participation, equity and empowerment programme with the organization‘s mission, priorities and managerial capacities.",
      column8: "Budget, Manage and Implement:\nDoes the organization have the capacity to involve citizens/customers in the development and delivery of programmes and services?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.4",
      column6: "No",
      column7: "Accountability   Inclusion, participation, equity and empowerment – Organizational level: Clarity and awareness of inclusion, participation, equity and empowerment goals and priorities among management.",
      column8: "Budget, Manage and Implement:\nDoes the organization have the capacity to involve citizens/customers in the development and delivery of programmes and services?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.4",
      column6: "No",
      column7: "Accountability   Inclusion, participation, equity and empowerment – Organizational level: Degree of enforcement of inclusion, participation, equity and empowerment mechanisms.",
      column8: "Budget, Manage and Implement:\nDoes the organization have the capacity to involve citizens/customers in the development and delivery of programmes and services?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.4",
      column6: "No",
      column7: "Accountability   Inclusion, participation, equity and empowerment – Organizational level: Degree of organizational support for effective functioning of CSO/CBOs.",
      column8: "Engage Stakeholders:\nDoes the organization have the capacity to engage stakeholders in the process of developing public engagement policies, frameworks and mechanisms?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.4",
      column6: "No",
      column7: "Accountability   Inclusion, participation, equity and empowerment – Organizational level: Existence and effectiveness of dialogue mechanisms (and other links as appropriate) between the organization and relevant domestic and external stakeholders on issues relating to inclusion, participation, equity and empowerment.",
      column8: "Engage Stakeholders:\nDoes the organization have the capacity to engage stakeholders in the process of developing public engagement policies, frameworks and mechanisms?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.4",
      column6: "No",
      column7: "Accountability   Inclusion, participation, equity and empowerment – Organizational level: Existence of clear and well understood inclusion and feedback mechanisms.",
      column8: "Evaluate:\nDoes the organization have the capacity to ensure availability and accessibility of communication and feedback mechanisms for employees, customers and other key stakeholders to be heard?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.4",
      column6: "No",
      column7: "Accountability   Inclusion, participation, equity and empowerment – Organizational level: Existence of mechanisms to register the voice of customers and employees and their perceptions.",
      column8: "Evaluate:\nDoes the organization have the capacity to ensure availability and accessibility of communication and feedback mechanisms for employees, customers and other key stakeholders to be heard?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.4",
      column6: "No",
      column7: "Accountability   Inclusion, participation, equity and empowerment – Organizational level: Existence of special and/or provisional measures to ensure partnerships with all excluded groups.",
      column8: "Engage Stakeholders:\nDoes the organization have the capacity to engage stakeholders in the process of developing public engagement policies, frameworks and mechanisms?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.4",
      column6: "No",
      column7: "Accountability   Inclusion, participation, equity and empowerment – Organizational level: Extent of use of new and innovative ways of dealing with citizens/customers.",
      column8: "Budget, Manage and Implement:\nDoes the organization have the capacity to involve citizens/customers in the development and delivery of programmes and services?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.4",
      column6: "No",
      column7: "Accountability   Inclusion, participation, equity and empowerment – Organizational level: Frequency and effectiveness of periodic publicity campaigns (in local languages) explaining the procedures and criteria for administrative decisions or processes.",
      column8: "Engage Stakeholders:\nDoes the organization have the capacity to engage stakeholders in the process of developing public engagement policies, frameworks and mechanisms?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.4",
      column6: "No",
      column7: "Accountability   Inclusion, participation, equity and empowerment – Organizational level: Level of civic engagement and bottom up influence on the organization's policy agenda and development.",
      column8: "Engage Stakeholders:\nDoes the organization have the capacity to engage stakeholders in the process of developing public engagement policies, frameworks and mechanisms?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.4",
      column6: "No",
      column7: "Accountability   Inclusion, participation, equity and empowerment – Organizational level: Level of effort to involve citizens/customers in the design of services or products and in decision making processes.",
      column8: "Engage Stakeholders:\nDoes the organization have the capacity to engage stakeholders in the process of developing public engagement policies, frameworks and mechanisms?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.4",
      column6: "No",
      column7: "Accountability   Inclusion, participation, equity and empowerment – Organizational level: Number and quality of citizen/customer suggestions received, recorded, acted upon.",
      column8: "Evaluate:\nDoes the organization have the capacity to ensure availability and accessibility of communication and feedback mechanisms for employees, customers and other key stakeholders to be heard?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.4",
      column6: "No",
      column7: "Accountability   Inclusion, participation, equity and empowerment – Organizational level: Quality (e.g., transparent, participatory, engaged, respective) and frequency of dialogue between the organization and domestic and external stakeholders.",
      column8: "Engage Stakeholders:\nDoes the organization have the capacity to engage stakeholders in the process of developing public engagement policies, frameworks and mechanisms?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.4",
      column6: "No",
      column7: "Accountability   Inclusion, participation, equity and empowerment – Organizational level: Quality of action taken as a result of 'critical events' analysis of opportunities and threats of most significance to the organization‘s inclusion, participation, equity and empowerment policies.",
      column8: "Assess a Situation and Define Vision and Mandate:\nDoes the organization have the capacity to frame, manage and interpret a comprehensive situation analysis for broad and meaningful participation? \nDoes the organization have the capacity to create a vision for broad and meaningful participation?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.4",
      column6: "No",
      column7: "Accountability   Inclusion, participation, equity and empowerment – Organizational level: Quality of analysis of environmental influences (at the appropriate level, e.g., market, sector) and their relative degree of impact on the organization‘s policies relating to inclusion, participation, equity and empowerment.",
      column8: "Assess a Situation and Define Vision and Mandate:\nDoes the organization have the capacity to frame, manage and interpret a comprehensive situation analysis for broad and meaningful participation? \nDoes the organization have the capacity to create a vision for broad and meaningful participation?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.4",
      column6: "No",
      column7: "Accountability   Inclusion, participation, equity and empowerment – Organizational level: Quality of mechanisms that ensure inclusion, participation, equity and empowerment.",
      column8: "Formulate Policies and Strategies:\nDoes the organization have the capacity to ensure involvement of interested parties throughout the process of developing policies and strategies?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.2",
      column6: "No",
      column7: "Accountability   Organizational level: Adherence to published service standards (e.g., customers‟ charters).",
      column8: "Evaluate:\nDoes the organization have the capacity to develop and manage accountability mechanisms for evaluation?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.2",
      column6: "No",
      column7: "Accountability   Organizational level: Degree of flexibility and ability to address individual situations.",
      column8: "Evaluate:\nDoes the organization have the capacity to develop and manage accountability mechanisms for evaluation?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.2",
      column6: "No",
      column7: "Accountability   Organizational level: Frequency of department client satisfaction surveys.",
      column8: "Evaluate:\nDoes the organization have the capacity to develop and manage accountability mechanisms for evaluation?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.2",
      column6: "No",
      column7: "Accountability   Organizational level: Frequency of rotation of employees in vulnerable positions so as to periodically change their physical / functional assignments.",
      column8: "Evaluate:\nDoes the organization have the capacity to develop and manage accountability mechanisms for evaluation?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.2",
      column6: "No",
      column7: "Accountability   Organizational level: Friendliness and fairness of treatment.",
      column8: "Evaluate:\nDoes the organization have the capacity to develop and manage accountability mechanisms for evaluation?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.2",
      column6: "No",
      column7: "Accountability   Organizational level: Level of responsiveness and pro active behavior.",
      column8: "Evaluate:\nDoes the organization have the capacity to develop and manage accountability mechanisms for evaluation?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.2",
      column6: "No",
      column7: "Accountability   Organizational level: Openness to change among managers.",
      column8: "Evaluate:\nDoes the organization have the capacity to develop and manage accountability mechanisms for evaluation?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "4.2",
      column6: "No",
      column7: "Accountability   Organizational level: Range of internal indicators to measure results achieved (e.g., number of complaints received, responded to; extent of effort to improve public trust in the organization and its services or products)",
      column8: "Evaluate:\nDoes the organization have the capacity to develop and manage accountability mechanisms for evaluation?"
    },
    {
      column1: "GLAAS Country Survey – Long Form, UNICEF and WHO",
      column2: "http://www.who.int/water_sanitation_health/monitoring/investments/glaas 2016 2017 cycle/en/",
      column3: "None found",
      column4: "None",
      column5: "C2",
      column6: "No",
      column7: "Constraints to WASH human resources",
      column8: "To what extent do the following factors constrain WASH human resources capacity?  [choices supplied]"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.5",
      column6: "No",
      column7: "Existence of a collective, nationally coordinated and defended, transparent and legitimate salary supplementation scheme linked to civil service reform.",
      column8: "Formulate Policies and Strategies: Do authorities have the capacity to develop policies and strategies relating to human resource development?"
    },
    {
      column1: "GLAAS Country Survey – Long Form, UNICEF and WHO",
      column2: "http://www.who.int/water_sanitation_health/monitoring/investments/glaas 2016 2017 cycle/en/",
      column3: "None found",
      column4: "None",
      column5: "C1a",
      column6: "No",
      column7: "HR Strategy Existence",
      column8: "Does an overall HR strategy exist to develop and manage human resources in sanitation and drinking water?"
    },
    {
      column1: "GLAAS Country Survey – Long Form, UNICEF and WHO",
      column2: "http://www.who.int/water_sanitation_health/monitoring/investments/glaas 2016 2017 cycle/en/",
      column3: "None found",
      column4: "None",
      column5: "C1b",
      column6: "No",
      column7: "HR Strategy identifies needs",
      column8: "If an HR strategy exists or is under development, has an HR gap been identified?"
    },
    {
      column1: "GLAAS Country Survey – Long Form, UNICEF and WHO",
      column2: "http://www.who.int/water_sanitation_health/monitoring/investments/glaas 2016 2017 cycle/en/",
      column3: "None found",
      column4: "None",
      column5: "C1c",
      column6: "No",
      column7: "HR strategy outlines actions to fill needs",
      column8: "If an HR strategy exists or is under development, does it outline actions to fill identified gaps in HR?"
    },
    {
      column1: "GLAAS Country Survey – Long Form, UNICEF and WHO",
      column2: "http://www.who.int/water_sanitation_health/monitoring/investments/glaas 2016 2017 cycle/en/",
      column3: "None found",
      column4: "None",
      column5: "C1d",
      column6: "No",
      column7: "HR strategy review",
      column8: "How often is / (will) the human resources strategy (be) reviewed?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.1",
      column6: "No",
      column7: "Institutional Arrangements   Enabling environment: Alignment of policy and legal framework with government‘s mission and priorities;  and managerial capacities",
      column8: "Budget, Manage and Implement: Do authorities have the capacity to develop policy, legal and regulatory frameworks and  mechanisms that support an integrated approach to budgeting and implementation?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.1",
      column6: "No",
      column7: "Institutional Arrangements   Enabling environment: Clarity and awareness of policy  and legal framework among leaders",
      column8: "Institutional Arrangements   Enabling environment: Budget, Manage and Implement: Do authorities have the capacity to develop policy, legal and regulatory frameworks and  mechanisms that support an integrated approach to budgeting and implementation?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.1",
      column6: "No",
      column7: "Institutional Arrangements   Enabling environment: Clarity of policy and legal framework to domestic and external stakeholders",
      column8: "Engage Stakeholders: Do authorities have the capacity to develop policies and legal and regulatory frameworks and mechanisms that ensure multi stakeholder participation?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.1",
      column6: "No",
      column7: "Institutional Arrangements   Enabling environment: Degree of 'rule of law', equality of citizens, access to justice",
      column8: "Institutional Arrangements   Enabling environment: Evaluate: Do authorities have the capacity to develop policies and legal and regulatory  frameworks and mechanisms for evaluation ?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.1",
      column6: "No",
      column7: "Institutional Arrangements   Enabling environment: Existence and effectiveness of dialogue mechanisms (and other links as appropriate) among domestic institutions to discuss formulation and implementation of the Government's policy and legal framework",
      column8: "Engage Stakeholders: Do authorities have the capacity to develop policies and legal and regulatory frameworks and mechanisms that ensure multi stakeholder participation?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.1",
      column6: "No",
      column7: "Institutional Arrangements   Enabling environment: Existence of clear 'rules of the game'  and safeguards that establish legitimate domestic partners and policy processes as leading on policy choice",
      column8: "Assess a Situation and Define Vision and Mandate: Do authorities have the capacity to frame, manage and interpret a comprehensive analysis of the policy and legal environment?  Do authorities have the capacity to create a vision for fair and equitable policies and legal and regulatory frameworks and mechanisms?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.1",
      column6: "No",
      column7: "Institutional Arrangements   Enabling environment: Existence of evaluation guidelines, procedures, etc.",
      column8: "Institutional Arrangements   Enabling environment: Evaluate: Do authorities have the capacity to develop policies and legal and regulatory  frameworks and mechanisms for evaluation ?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.1",
      column6: "No",
      column7: "Institutional Arrangements   Enabling environment: Existence of legal framework for processing complaints about public sector  performance issues",
      column8: "Institutional Arrangements   Enabling environment: Evaluate: Do authorities have the capacity to develop policies and legal and regulatory  frameworks and mechanisms for evaluation ?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.1",
      column6: "Yes",
      column7: "Institutional Arrangements   Enabling environment: Existence of long   term strategic choices on policy and legal frameworks",
      column8: "Formulate Policies  and Strategies: Do authorities have the capacity to develop  policy, legal and regulatory frameworks and  mechanisms?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.1",
      column6: "No",
      column7: "Institutional Arrangements   Enabling environment: Existence of monitoring guidelines, procedures etc",
      column8: "Institutional Arrangements   Enabling environment: Budget, Manage and Implement: Do authorities have the capacity to develop policy, legal and regulatory frameworks and  mechanisms that support an integrated approach to budgeting and implementation?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.1",
      column6: "Yes",
      column7: "Institutional Arrangements   Enabling environment: Existence of policy and legal framework that is independent, impartial and fair",
      column8: "Formulate Policies  and Strategies: Do authorities have the capacity to develop  policy, legal and regulatory frameworks and  mechanisms?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.1",
      column6: "No",
      column7: "Institutional Arrangements   Enabling environment: Extent to which legal profession is subject to disciplinary measures",
      column8: "Institutional Arrangements   Enabling environment: Evaluate: Do authorities have the capacity to develop policies and legal and regulatory  frameworks and mechanisms for evaluation ?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.1",
      column6: "No",
      column7: "Institutional Arrangements   Enabling environment: Extent to which policy and legal framework contributes to achievement of overall  goals and strategies",
      column8: "Budget, Manage and Implement: Do authorities have the capacity to develop policy, legal and regulatory frameworks and  mechanisms that support an integrated approach to budgeting and implementation?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.1",
      column6: "No",
      column7: "Institutional Arrangements   Enabling environment: Extent to which societal changes are integrated into Government's policy and legal  framework",
      column8: "Formulate Policies  and Strategies: Do authorities have the capacity to develop  policy, legal and regulatory frameworks and  mechanisms?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.1",
      column6: "No",
      column7: "Institutional Arrangements   Enabling environment: Level of corruption",
      column8: "Institutional Arrangements   Enabling environment: Evaluate: Do authorities have the capacity to develop policies and legal and regulatory  frameworks and mechanisms for evaluation ?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.1",
      column6: "No",
      column7: "Institutional Arrangements   Enabling environment: Quality (e.g., transparent, participatory, engaged, respective) and frequency of dialogue between and among domestic and external stakeholders",
      column8: "Engage Stakeholders: Do authorities have the capacity to develop policies and legal and regulatory frameworks and mechanisms that ensure multi stakeholder participation?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.1",
      column6: "No",
      column7: "Institutional Arrangements   Enabling environment: Quality of action taken as a result of 'critical events' , analysis of opportunities and threats of most significance to Government‘s policy and legal framework",
      column8: "Assess a Situation and Define Vision and Mandate: Do authorities have the capacity to frame, manage and interpret a comprehensive analysis of the policy and legal environment?  Do authorities have the capacity to create a vision for fair and equitable policies and legal and regulatory frameworks and mechanisms?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.1",
      column6: "No",
      column7: "Institutional Arrangements   Enabling environment: Quality of analysis of environmental influences (at the appropriate level, e.g., market, sector) and their relative degree of impact.",
      column8: "Assess a Situation and Define Vision and Mandate: Do authorities have the capacity to frame, manage and interpret a comprehensive analysis of the policy and legal environment?  \nDo authorities have the capacity to create a vision for fair and equitable policies and legal and regulatory frameworks and mechanisms?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.3",
      column6: "No",
      column7: "Institutional Arrangements   Financial management   Enabling environment: Accuracy and currency of fiscal data.",
      column8: "Budget, Manage and Implement: Do authorities have the capacity to manage financial resources appropriately in the implementation of programmes and delivery of services?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.3",
      column6: "No",
      column7: "Institutional Arrangements   Financial management   Enabling environment: Accuracy of financial forecasts.",
      column8: "Assess a Situation and Define Vision and Mandate: Do authorities have the capacity to frame, manage and interpret a comprehensive situation analysis of and to create a vision for the country's financial assets as they relate to delivering the MDGs and other international goals and commitments?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.3",
      column6: "No",
      column7: "Institutional Arrangements   Financial management   Enabling environment: Awareness of future resource needs among government authorities.",
      column8: "Assess a Situation and Define Vision and Mandate: Do authorities have the capacity to frame, manage and interpret a comprehensive situation analysis of and to create a vision for the country's financial assets as they relate to delivering the MDGs and other international goals and commitments?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.3",
      column6: "No",
      column7: "Institutional Arrangements   Financial management   Enabling environment: Clarity and awareness of financial resource goals and priorities among leaders.",
      column8: "Budget, Manage and Implement: Do authorities have the capacity to manage financial resources appropriately in the implementation of programmes and delivery of services?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.3",
      column6: "No",
      column7: "Institutional Arrangements   Financial management   Enabling environment: Degree of enforcement of financial resource management policies and mechanisms.",
      column8: "Budget, Manage and Implement: Do authorities have the capacity to manage financial resources appropriately in the implementation of programmes and delivery of services?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.3",
      column6: "No",
      column7: "Institutional Arrangements   Financial management   Enabling environment: Effective financial management and accounting procedures.",
      column8: "Budget, Manage and Implement: Do authorities have the capacity to manage financial resources appropriately in the implementation of programmes and delivery of services?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.3",
      column6: "No",
      column7: "Institutional Arrangements   Financial management   Enabling environment: Evidence of ability to satisfy and balance the financial interests of all stakeholders.",
      column8: "Engage stakeholders: Do authorities have the capacity to develop an MDG based financial plan, with the involvement of domestic and external stakeholders?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.3",
      column6: "No",
      column7: "Institutional Arrangements   Financial management   Enabling environment: Existence and effectiveness of dialogue mechanisms (and other links as appropriate) between and among the government and domestic and external stakeholders on issues relating to financial resource management.",
      column8: "Engage stakeholders: Do authorities have the capacity to develop an MDG based financial plan, with the involvement of domestic and external stakeholders?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.3",
      column6: "No",
      column7: "Institutional Arrangements   Financial management   Enabling environment: Financial sustainability of national organizations (measured by e.g., amount of funds raised, number of organizations where at least xx funding sources contribute at least xx% each).",
      column8: "Evaluate: Do authorities have the capacity to ensure, through monitoring and evaluation, proper use of financial resources?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.3",
      column6: "No",
      column7: "Institutional Arrangements   Financial management   Enabling environment: Frequency and results of financial audits and inspections (internal and external).",
      column8: "Evaluate: Do authorities have the capacity to ensure, through monitoring and evaluation, proper use of financial resources?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.3",
      column6: "No",
      column7: "Institutional Arrangements   Financial management   Enabling environment: Government control over its own budget and financial resource policies.",
      column8: "Budget, Manage and Implement: Do authorities have the capacity to manage financial resources appropriately in the implementation of programmes and delivery of services?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.3",
      column6: "No",
      column7: "Institutional Arrangements   Financial management   Enabling environment: Measures of effective use of operating funds (to avoid exceeding any credit limit or under exploiting resources).",
      column8: "Evaluate: Do authorities have the capacity to ensure, through monitoring and evaluation, proper use of financial resources?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.3",
      column6: "No",
      column7: "Institutional Arrangements   Financial management   Enabling environment: Measures of prudent and risk conscious financial management.",
      column8: "Evaluate: Do authorities have the capacity to ensure, through monitoring and evaluation, proper use of financial resources?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.3",
      column6: "No",
      column7: "Institutional Arrangements   Financial management   Enabling environment: Quality (e.g., transparent, participatory, engaged, respective) and frequency of dialogue between and among the government and domestic and external stakeholders.",
      column8: "Engage stakeholders: Do authorities have the capacity to develop an MDG based financial plan, with the involvement of domestic and external stakeholders?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.3",
      column6: "No",
      column7: "Institutional Arrangements   Financial management   Enabling environment: Quality of action taken as a result of critical events‘ analysis of opportunities and threats of most significance to the government‘s financial resource management policies.",
      column8: "Assess a Situation and Define Vision and Mandate: Do authorities have the capacity to frame, manage and interpret a comprehensive situation analysis of and to create a vision for the country's financial assets as they relate to delivering the MDGs and other international goals and commitments?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.3",
      column6: "No",
      column7: "Institutional Arrangements   Financial management   Enabling environment: Share of finance going through legitimate domestic institutions.",
      column8: "Evaluate: Do authorities have the capacity to ensure, through monitoring and evaluation, proper use of financial resources?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.3",
      column6: "No",
      column7: "Institutional Arrangements   Financial management   Enabling environment: Transparency of budgeting, planning and allocation process.",
      column8: "Budget, Manage and Implement: Do authorities have the capacity to manage financial resources appropriately in the implementation of programmes and delivery of services?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.3",
      column6: "No",
      column7: "Institutional Arrangements   Financial management   Enabling environment: Use of budgets as a monitoring tool. (Extent to which budgets/financial targets are met).",
      column8: "Evaluate: Do authorities have the capacity to ensure, through monitoring and evaluation, proper use of financial resources?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.3",
      column6: "No",
      column7: "Institutional Arrangements   Financial management   Enabling environment: Use of budgets as a planning tool.",
      column8: "Budget, Manage and Implement: Do authorities have the capacity to manage financial resources appropriately in the implementation of programmes and delivery of services?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.4",
      column6: "No",
      column7: "Institutional Arrangements   Financial management   Organizational level: Accuracy and currency of fiscal data.",
      column8: "Budget, Manage and Implement: Does the organization have the capacity to manage financial resources appropriately in the implementation of programmes and delivery of services?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.4",
      column6: "No",
      column7: "Institutional Arrangements   Financial management   Organizational level: Accuracy of financial forecasts.",
      column8: "Assess a Situation and Define Vision and Mandate: Does the organization have the capacity to frame, manage and interpret a comprehensive financial analysis and to create a vision for use of financial resources?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.4",
      column6: "No",
      column7: "Institutional Arrangements   Financial management   Organizational level: Alignment of financial resources with planning budgets (including credit, where appropriate).",
      column8: "Budget, Manage and Implement: Does the organization have the capacity to manage financial resources appropriately in the implementation of programmes and delivery of services?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.4",
      column6: "No",
      column7: "Institutional Arrangements   Financial management   Organizational level: Alignment of scope of program or other activities with the organization‘s financial resources.",
      column8: "Budget, Manage and Implement: Does the organization have the capacity to manage financial resources appropriately in the implementation of programmes and delivery of services?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.4",
      column6: "No",
      column7: "Institutional Arrangements   Financial management   Organizational level: Awareness of future resource needs among organizational leadership.",
      column8: "Assess a Situation and Define Vision and Mandate: Does the organization have the capacity to frame, manage and interpret a comprehensive financial analysis and to create a vision for use of financial resources?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.4",
      column6: "No",
      column7: "Institutional Arrangements   Financial management   Organizational level: Clarity and awareness of financial resource goals and priorities among leaders.",
      column8: "Budget, Manage and Implement: Does the organization have the capacity to manage financial resources appropriately in the implementation of programmes and delivery of services?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.4",
      column6: "No",
      column7: "Institutional Arrangements   Financial management   Organizational level: Degree of enforcement of financial resource management policies and mechanisms.",
      column8: "Budget, Manage and Implement: Does the organization have the capacity to manage financial resources appropriately in the implementation of programmes and delivery of services?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.4",
      column6: "No",
      column7: "Institutional Arrangements   Financial management   Organizational level: Effective financial management and accounting procedures.",
      column8: "Budget, Manage and Implement: Does the organization have the capacity to manage financial resources appropriately in the implementation of programmes and delivery of services?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.4",
      column6: "No",
      column7: "Institutional Arrangements   Financial management   Organizational level: Evidence of ability to satisfy and balance the financial interests of all stakeholders.",
      column8: "Engage Stakeholders: Does the organization have the capacity to engage stakeholders in the process of developing a financial plan?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.4",
      column6: "No",
      column7: "Institutional Arrangements   Financial management   Organizational level: Existence and effectiveness of dialogue mechanisms (and other links as appropriate) between the organization and relevant domestic and external stakeholders on issues relating to financial resource management.",
      column8: "Engage Stakeholders: Does the organization have the capacity to engage stakeholders in the process of developing a financial plan?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.4",
      column6: "No",
      column7: "Institutional Arrangements   Financial management   Organizational level: Existence of long term strategic policy options for financial resource management.",
      column8: "Formulate Policies and Strategies: Does the organization have the capacity to develop a financial plan and policies?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.4",
      column6: "No",
      column7: "Institutional Arrangements   Financial management   Organizational level: Extent to which societal changes are integrated into the organization's financial resource management policies and mechanisms.",
      column8: "Formulate Policies and Strategies: Does the organization have the capacity to develop a financial plan and policies?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.4",
      column6: "No",
      column7: "Institutional Arrangements   Financial management   Organizational level: Frequency and results of financial audits and inspections (internal and external).",
      column8: "Evaluate: Does the organization have the capacity to ensure, through evaluation, proper use of financial resources?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.4",
      column6: "No",
      column7: "Institutional Arrangements   Financial management   Organizational level: Measures of effective use of operating funds (to avoid exceeding any credit limit or under exploiting resources).",
      column8: "Evaluate: Does the organization have the capacity to ensure, through evaluation, proper use of financial resources?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.4",
      column6: "No",
      column7: "Institutional Arrangements   Financial management   Organizational level: Measures of prudent and risk conscious financial management.",
      column8: "Evaluate: Does the organization have the capacity to ensure, through evaluation, proper use of financial resources?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.4",
      column6: "No",
      column7: "Institutional Arrangements   Financial management   Organizational level: Operational efficiency of organizational subsystems for financial resource management.",
      column8: "Budget, Manage and Implement: Does the organization have the capacity to manage financial resources appropriately in the implementation of programmes and delivery of services?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.4",
      column6: "No",
      column7: "Institutional Arrangements   Financial management   Organizational level: Organizational control of budget and financial resource policies.",
      column8: "Budget, Manage and Implement: Does the organization have the capacity to manage financial resources appropriately in the implementation of programmes and delivery of services?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.4",
      column6: "No",
      column7: "Institutional Arrangements   Financial management   Organizational level: Quality (e.g., transparent, participatory, engaged, respective) and frequency of dialogue between the organization and domestic and external stakeholders.",
      column8: "Engage Stakeholders: Does the organization have the capacity to engage stakeholders in the process of developing a financial plan?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.4",
      column6: "No",
      column7: "Institutional Arrangements   Financial management   Organizational level: Quality of action taken as a result of 'critical events' analysis of opportunities and threats of most significance to the organization‘s financial resource management policies.",
      column8: "Assess a Situation and Define Vision and Mandate: Does the organization have the capacity to frame, manage and interpret a comprehensive financial analysis and to create a vision for use of financial resources?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.4",
      column6: "No",
      column7: "Institutional Arrangements   Financial management   Organizational level: Quality of analysis of environmental influences (at the appropriate level, e.g., market, sector) and their relative degree of impact on policies relating to financial resource management.",
      column8: "Assess a Situation and Define Vision and Mandate: Does the organization have the capacity to frame, manage and interpret a comprehensive financial analysis and to create a vision for use of financial resources?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.4",
      column6: "No",
      column7: "Institutional Arrangements   Financial management   Organizational level: Transparency of budgeting, planning and allocation process.",
      column8: "Budget, Manage and Implement: Does the organization have the capacity to manage financial resources appropriately in the implementation of programmes and delivery of services?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.4",
      column6: "No",
      column7: "Institutional Arrangements   Financial management   Organizational level: Use of budgets as a monitoring tool. (Extent to which budgets/ financial targets are met.)",
      column8: "Budget, Manage and Implement: Does the organization have the capacity to manage financial resources appropriately in the implementation of programmes and delivery of services?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.4",
      column6: "No",
      column7: "Institutional Arrangements   Financial management   Organizational level: Use of budgets as a planning tool.",
      column8: "Budget, Manage and Implement: Does the organization have the capacity to manage financial resources appropriately in the implementation of programmes and delivery of services?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.5",
      column6: "No",
      column7: "Institutional Arrangements   Human resource management   Enabling environment: Accountability of staff for getting work done according to clear performance standards.",
      column8: "Evaluate: Do authorities have the capacity to evaluate performance and trends in HR capacity and productivity enhancement?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.5",
      column6: "No",
      column7: "Institutional Arrangements   Human resource management   Enabling environment: Adequacy and equity of compensation.",
      column8: "Evaluate: Do authorities have the capacity to evaluate performance and trends in HR capacity and productivity enhancement?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.5",
      column6: "No",
      column7: "Institutional Arrangements   Human resource management   Enabling environment: Adequacy of staff in all key positions.",
      column8: "Evaluate: Do authorities have the capacity to evaluate performance and trends in HR capacity and productivity enhancement?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.5",
      column6: "No",
      column7: "Institutional Arrangements   Human resource management   Enabling environment: Alignment of human resource management programme with government‘s mission, priorities and managerial capacities.",
      column8: "Budget, Manage and Implement:\nDo authorities have the capacity to leverage human resources appropriately in the budgeting, management and implementation of programmes and delivery of services?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.5",
      column6: "No",
      column7: "Institutional Arrangements   Human resource management   Enabling environment: Alignment of staff attitude and performance with overall goals.",
      column8: "Budget, Manage and Implement:\nDo authorities have the capacity to leverage human resources appropriately in the budgeting, management and implementation of programmes and delivery of services?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.5",
      column6: "No",
      column7: "Institutional Arrangements   Human resource management   Enabling environment: Clarity and awareness of human resource goals and priorities among leaders.",
      column8: "Budget, Manage and Implement:\nDo authorities have the capacity to leverage human resources appropriately in the budgeting, management and implementation of programmes and delivery of services?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.5",
      column6: "No",
      column7: "Institutional Arrangements   Human resource management   Enabling environment: Degree of enforcement of human resource management policies and mechanisms.",
      column8: "Budget, Manage and Implement:\nDo authorities have the capacity to leverage human resources appropriately in the budgeting, management and implementation of programmes and delivery of services?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.5",
      column6: "No",
      column7: "Institutional Arrangements   Human resource management   Enabling environment: Degree of orientation of staff at all levels toward producing results that meet overall goals.",
      column8: "Budget, Manage and Implement:\nDo authorities have the capacity to leverage human resources appropriately in the budgeting, management and implementation of programmes and delivery of services?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.5",
      column6: "No",
      column7: "Institutional Arrangements   Human resource management   Enabling environment: Degree to which government learns from its mistakes and staff is rewarded for confronting rather than concealing errors.",
      column8: "Evaluate: Do authorities have the capacity to evaluate performance and trends in HR capacity and productivity enhancement?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.5",
      column6: "No",
      column7: "Institutional Arrangements   Human resource management   Enabling environment: Degree to which ministers respect the independence and professionalism of their senior civil servants.",
      column8: "Engage Stakeholders: Do authorities have the capacity to develop HR policies that ensure multi stakeholder participation?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.5",
      column6: "No",
      column7: "Institutional Arrangements   Human resource management   Enabling environment: Degree to which monetary and non monetary incentives support targeted behavior.",
      column8: "Evaluate: Do authorities have the capacity to evaluate performance and trends in HR capacity and productivity enhancement?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.5",
      column6: "No",
      column7: "Institutional Arrangements   Human resource management   Enabling environment: Degree to which recruitment and promotion policies provide for staff growth.",
      column8: "Evaluate: Do authorities have the capacity to evaluate performance and trends in HR capacity and productivity enhancement?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.5",
      column6: "No",
      column7: "Institutional Arrangements   Human resource management   Enabling environment: Degree to which senior civil servants are generally expected to provide 'frank and fearless' advice to Ministers.",
      column8: "Engage Stakeholders: Do authorities have the capacity to develop HR policies that ensure multi stakeholder participation?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.5",
      column6: "No",
      column7: "Institutional Arrangements   Human resource management   Enabling environment: Degree to which staff needs are analyzed in the planning process.",
      column8: "Assess a Situation and Define Vision and Mandate: Do authorities have the capacity to frame, manage and interpret a comprehensive situation analysis of and to create a vision for the country's HR assets and needs as they relate to delivering the MDGs and other international goals and commitments?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.5",
      column6: "No",
      column7: "Institutional Arrangements   Human resource management   Enabling environment: Existence and effectiveness of dialogue mechanisms (and other links as appropriate) between and among the government and domestic and external stakeholders on issues relating to human resource management.",
      column8: "Engage Stakeholders: Do authorities have the capacity to develop HR policies that ensure multi stakeholder participation?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.5",
      column6: "No",
      column7: "Institutional Arrangements   Human resource management   Enabling environment: Existence of fully developed competency profiles application to all functional areas and specific levels.",
      column8: "Budget, Manage and Implement:\nDo authorities have the capacity to leverage human resources appropriately in the budgeting, management and implementation of programmes and delivery of services?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.5",
      column6: "Yes",
      column7: "Institutional Arrangements   Human resource management   Enabling environment: Existence of long term strategic policy options for human resource management.",
      column8: "Formulate Policies and Strategies: Do authorities have the capacity to develop policies and strategies relating to human resource development?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.5",
      column6: "No",
      column7: "Institutional Arrangements   Human resource management   Enabling environment: Explicit integration of incentive questions as standing feature in mainstream M&E.",
      column8: "Evaluate: Do authorities have the capacity to evaluate performance and trends in HR capacity and productivity enhancement?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.5",
      column6: "No",
      column7: "Institutional Arrangements   Human resource management   Enabling environment: Extent to which societal changes are integrated into Government's human resource management policies and mechanisms.",
      column8: "Formulate Policies and Strategies: Do authorities have the capacity to develop policies and strategies relating to human resource development?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.5",
      column6: "No",
      column7: "Institutional Arrangements   Human resource management   Enabling environment: Government control over its own human resource policies.",
      column8: "Budget, Manage and Implement:\nDo authorities have the capacity to leverage human resources appropriately in the budgeting, management and implementation of programmes and delivery of services?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.5",
      column6: "No",
      column7: "Institutional Arrangements   Human resource management   Enabling environment: Job satisfaction at all levels of government.",
      column8: "Evaluate: Do authorities have the capacity to evaluate performance and trends in HR capacity and productivity enhancement?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.5",
      column6: "No",
      column7: "Institutional Arrangements   Human resource management   Enabling environment: Level of staff morale; frequency of evaluation of staff morale.",
      column8: "Evaluate: Do authorities have the capacity to evaluate performance and trends in HR capacity and productivity enhancement?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.5",
      column6: "No",
      column7: "Institutional Arrangements   Human resource management   Enabling environment: Opportunities for staff professional development and on the job training.",
      column8: "Evaluate: Do authorities have the capacity to evaluate performance and trends in HR capacity and productivity enhancement?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.5",
      column6: "No",
      column7: "Institutional Arrangements   Human resource management   Enabling environment: Quality (e.g., transparent, participatory, engaged, respective) and frequency of dialogue between and among the government and domestic and external stakeholders.",
      column8: "Engage Stakeholders: Do authorities have the capacity to develop HR policies that ensure multi stakeholder participation?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.5",
      column6: "No",
      column7: "Institutional Arrangements   Human resource management   Enabling environment: Quality of action taken as a result of critical events‘ analysis of opportunities and threats of most significance to the government‘s human resource management policies.",
      column8: "Assess a Situation and Define Vision and Mandate: Do authorities have the capacity to frame, manage and interpret a comprehensive situation analysis of and to create a vision for the country's HR assets and needs as they relate to delivering the MDGs and other international goals and commitments?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.5",
      column6: "No",
      column7: "Institutional Arrangements   Human resource management   Enabling environment: Quality of analysis of environmental influences (at the appropriate level, e.g., market, sector) and their relative degree of impact on policies relating to human resource management.",
      column8: "Assess a Situation and Define Vision and Mandate: Do authorities have the capacity to frame, manage and interpret a comprehensive situation analysis of and to create a vision for the country's HR assets and needs as they relate to delivering the MDGs and other international goals and commitments?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.5",
      column6: "No",
      column7: "Institutional Arrangements   Human resource management   Enabling environment: Staff turnover rate.",
      column8: "Evaluate: Do authorities have the capacity to evaluate performance and trends in HR capacity and productivity enhancement?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.5",
      column6: "No",
      column7: "Institutional Arrangements   Human resource management   Enabling environment: Transparency of human resource planning and allocation process.",
      column8: "Budget, Manage and Implement:\nDo authorities have the capacity to leverage human resources appropriately in the budgeting, management and implementation of programmes and delivery of services?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.5",
      column6: "No",
      column7: "Institutional Arrangements   Human resource management   Enabling environment: Use of human resource management plan as a monitoring tool.",
      column8: "Budget, Manage and Implement:\nDo authorities have the capacity to leverage human resources appropriately in the budgeting, management and implementation of programmes and delivery of services?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.6",
      column6: "No",
      column7: "Institutional Arrangements   Human resource management   Organizational level: Accountability of staff for getting work done according to clear performance standards.",
      column8: "Evaluate:\nDoes the organization have the capacity to evaluate the development and implementation of HR policy and encourage evaluation and feedback?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.6",
      column6: "No",
      column7: "Institutional Arrangements   Human resource management   Organizational level: Adequacy and equity of compensation.",
      column8: "Evaluate:\nDoes the organization have the capacity to evaluate the development and implementation of HR policy and encourage evaluation and feedback?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.6",
      column6: "No",
      column7: "Institutional Arrangements   Human resource management   Organizational level: Adequacy of staff in all key positions.",
      column8: "Evaluate:\nDoes the organization have the capacity to evaluate the development and implementation of HR policy and encourage evaluation and feedback?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.6",
      column6: "No",
      column7: "Institutional Arrangements   Human resource management   Organizational level: Alignment of human resource management programme with the organization‘s mission, priorities and managerial capacities.",
      column8: "Budget, Manage and Implement: Does the organization have the capacity to develop, use and improve competencies of employees?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.6",
      column6: "No",
      column7: "Institutional Arrangements   Human resource management   Organizational level: Alignment of staff attitude and performance with overall goals.",
      column8: "Budget, Manage and Implement: Does the organization have the capacity to develop, use and improve competencies of employees?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.6",
      column6: "No",
      column7: "Institutional Arrangements   Human resource management   Organizational level: Clarity and awareness of human resource goals and priorities among senior managers.",
      column8: "Budget, Manage and Implement: Does the organization have the capacity to develop, use and improve competencies of employees?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.6",
      column6: "No",
      column7: "Institutional Arrangements   Human resource management   Organizational level: Degree of enforcement of human resource management policies and mechanisms.",
      column8: "Budget, Manage and Implement: Does the organization have the capacity to develop, use and improve competencies of employees?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.6",
      column6: "No",
      column7: "Institutional Arrangements   Human resource management   Organizational level: Degree of orientation of staff at all levels toward producing results that meet organizational goals.",
      column8: "Budget, Manage and Implement: Does the organization have the capacity to develop, use and improve competencies of employees?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.6",
      column6: "No",
      column7: "Institutional Arrangements   Human resource management   Organizational level: Degree to which executives (managers) respect the independence and professionalism of their senior level managers (staff).",
      column8: "Engage Stakeholders:\nDoes the organization have the capacity to engage stakeholders in the process of developing HR policies?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.6",
      column6: "No",
      column7: "Institutional Arrangements   Human resource management   Organizational level: Degree to which monetary and non monetary incentives support targeted behavior.",
      column8: "Evaluate:\nDoes the organization have the capacity to evaluate the development and implementation of HR policy and encourage evaluation and feedback?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.6",
      column6: "No",
      column7: "Institutional Arrangements   Human resource management   Organizational level: Degree to which organizational structure meets needs of efficiency and control.",
      column8: "Budget, Manage and Implement: Does the organization have the capacity to develop, use and improve competencies of employees?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.6",
      column6: "No",
      column7: "Institutional Arrangements   Human resource management   Organizational level: Degree to which recruitment and promotion policies provide for staff growth.",
      column8: "Evaluate:\nDoes the organization have the capacity to evaluate the development and implementation of HR policy and encourage evaluation and feedback?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.6",
      column6: "No",
      column7: "Institutional Arrangements   Human resource management   Organizational level: Degree to which senior level managers (staff) are generally expected to provide 'frank and fearless‘ advice to their superiors.",
      column8: "Engage Stakeholders:\nDoes the organization have the capacity to engage stakeholders in the process of developing HR policies?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.6",
      column6: "No",
      column7: "Institutional Arrangements   Human resource management   Organizational level: Degree to which staff needs are analyzed in the planning process.",
      column8: "Assess a Situation and Define Vision and Mandate: Does the organization have the capacity to frame, manage and interpret a comprehensive situation analysis of and to create a vision for human resource development?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.6",
      column6: "No",
      column7: "Institutional Arrangements   Human resource management   Organizational level: Effectiveness of systems of goal setting and performance evaluation.",
      column8: "Evaluate:\nDoes the organization have the capacity to evaluate the development and implementation of HR policy and encourage evaluation and feedback?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.6",
      column6: "No",
      column7: "Institutional Arrangements   Human resource management   Organizational level: Efficiency of organization's processes.",
      column8: "Budget, Manage and Implement: Does the organization have the capacity to develop, use and improve competencies of employees?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.6",
      column6: "No",
      column7: "Institutional Arrangements   Human resource management   Organizational level: Employee consultation and dialogue mechanisms.",
      column8: "Engage Stakeholders:\nDoes the organization have the capacity to engage stakeholders in the process of developing HR policies?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.6",
      column6: "No",
      column7: "Institutional Arrangements   Human resource management   Organizational level: Employee involvement in decision making processes.",
      column8: "Engage Stakeholders:\nDoes the organization have the capacity to engage stakeholders in the process of developing HR policies?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.6",
      column6: "No",
      column7: "Institutional Arrangements   Human resource management   Organizational level: Employee involvement in improvement activities (e.g., suggestion schemes).",
      column8: "Engage Stakeholders:\nDoes the organization have the capacity to engage stakeholders in the process of developing HR policies?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.6",
      column6: "No",
      column7: "Institutional Arrangements   Human resource management   Organizational level: Existence and effectiveness of dialogue mechanisms (and other links as appropriate) between the organization and domestic and external stakeholders on issues relating to human resource management.",
      column8: "Engage Stakeholders:\nDoes the organization have the capacity to engage stakeholders in the process of developing HR policies?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.6",
      column6: "No",
      column7: "Institutional Arrangements   Human resource management   Organizational level: Existence of fully developed competency profiles application to all functional areas and specific levels.",
      column8: "Budget, Manage and Implement: Does the organization have the capacity to develop, use and improve competencies of employees?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.6",
      column6: "No",
      column7: "Institutional Arrangements   Human resource management   Organizational level: Existence of long term strategic policy options for human resource management.",
      column8: "Formulate Policies and Strategies: Does the organization have the capacity to develop policies and strategies relating to human resource development?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.6",
      column6: "No",
      column7: "Institutional Arrangements   Human resource management   Organizational level: Explicit integration of incentive questions as standing feature in mainstream M&E.",
      column8: "Evaluate:\nDoes the organization have the capacity to evaluate the development and implementation of HR policy and encourage evaluation and feedback?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.6",
      column6: "No",
      column7: "Institutional Arrangements   Human resource management   Organizational level: Extent to which societal changes are integrated into the organization's human resource management policies and mechanisms.",
      column8: "Formulate Policies and Strategies: Does the organization have the capacity to develop policies and strategies relating to human resource development?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.6",
      column6: "No",
      column7: "Institutional Arrangements   Human resource management   Organizational level: Job satisfaction at all levels of the organization.",
      column8: "Evaluate:\nDoes the organization have the capacity to evaluate the development and implementation of HR policy and encourage evaluation and feedback?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.6",
      column6: "No",
      column7: "Institutional Arrangements   Human resource management   Organizational level: Level and use of training budgets.",
      column8: "Budget, Manage and Implement: Does the organization have the capacity to develop, use and improve competencies of employees?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.6",
      column6: "No",
      column7: "Institutional Arrangements   Human resource management   Organizational level: Level of employee knowledge of the organization's goals.",
      column8: "Evaluate:\nDoes the organization have the capacity to evaluate the development and implementation of HR policy and encourage evaluation and feedback?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.6",
      column6: "No",
      column7: "Institutional Arrangements   Human resource management   Organizational level: Level of employee motivation (e.g., response rates for staff surveys, participation in social events, willingness to accept changes, willingness to make an extra effort under special circumstances).",
      column8: "Evaluate:\nDoes the organization have the capacity to evaluate the development and implementation of HR policy and encourage evaluation and feedback?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.6",
      column6: "No",
      column7: "Institutional Arrangements   Human resource management   Organizational level: Level of employee satisfaction with goal setting and performance evaluation processes.",
      column8: "Evaluate:\nDoes the organization have the capacity to evaluate the development and implementation of HR policy and encourage evaluation and feedback?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.6",
      column6: "No",
      column7: "Institutional Arrangements   Human resource management   Organizational level: Level of staff morale; frequency of evaluation of staff morale.",
      column8: "Evaluate:\nDoes the organization have the capacity to evaluate the development and implementation of HR policy and encourage evaluation and feedback?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.6",
      column6: "No",
      column7: "Institutional Arrangements   Human resource management   Organizational level: Link between individual performance and the quality of services or products.",
      column8: "Evaluate:\nDoes the organization have the capacity to evaluate the development and implementation of HR policy and encourage evaluation and feedback?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.6",
      column6: "No",
      column7: "Institutional Arrangements   Human resource management   Organizational level: Number of complaints, strikes, etc.",
      column8: "Evaluate:\nDoes the organization have the capacity to evaluate the development and implementation of HR policy and encourage evaluation and feedback?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.6",
      column6: "No",
      column7: "Institutional Arrangements   Human resource management   Organizational level: Opportunities for staff professional development and on the job training.",
      column8: "Evaluate:\nDoes the organization have the capacity to evaluate the development and implementation of HR policy and encourage evaluation and feedback?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.6",
      column6: "No",
      column7: "Institutional Arrangements   Human resource management   Organizational level: Participation and success rates in training activities.",
      column8: "Budget, Manage and Implement: Does the organization have the capacity to develop, use and improve competencies of employees?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.6",
      column6: "No",
      column7: "Institutional Arrangements   Human resource management   Organizational level: Participation in internal discussion groups, meetings with senior management or all staff meetings.",
      column8: "Engage Stakeholders:\nDoes the organization have the capacity to engage stakeholders in the process of developing HR policies?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.6",
      column6: "No",
      column7: "Institutional Arrangements   Human resource management   Organizational level: Quality (e.g., transparent, participatory, engaged, respective) and frequency of dialogue between the organization and domestic and external stakeholders.",
      column8: "Engage Stakeholders:\nDoes the organization have the capacity to engage stakeholders in the process of developing HR policies?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.6",
      column6: "No",
      column7: "Institutional Arrangements   Human resource management   Organizational level: Quality of action taken as a result of critical events‘ analysis of opportunities and threats of most significance to the organization‘s human resource management policies.",
      column8: "Assess a Situation and Define Vision and Mandate: Does the organization have the capacity to frame, manage and interpret a comprehensive situation analysis of and to create a vision for human resource development?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.6",
      column6: "No",
      column7: "Institutional Arrangements   Human resource management   Organizational level: Quality of analysis of environmental influences (at the appropriate level, e.g., market, sector) and their relative degree of impact on policies relating to human resource management.",
      column8: "Assess a Situation and Define Vision and Mandate: Does the organization have the capacity to frame, manage and interpret a comprehensive situation analysis of and to create a vision for human resource development?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.6",
      column6: "No",
      column7: "Institutional Arrangements   Human resource management   Organizational level: Results of evaluation and/or appraisal.",
      column8: "Evaluate:\nDoes the organization have the capacity to evaluate the development and implementation of HR policy and encourage evaluation and feedback?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.6",
      column6: "No",
      column7: "Institutional Arrangements   Human resource management   Organizational level: Staff rotation within the organization.",
      column8: "Budget, Manage and Implement: Does the organization have the capacity to develop, use and improve competencies of employees?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.6",
      column6: "No",
      column7: "Institutional Arrangements   Human resource management   Organizational level: Staff turnover rate.",
      column8: "Evaluate:\nDoes the organization have the capacity to evaluate the development and implementation of HR policy and encourage evaluation and feedback?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.6",
      column6: "No",
      column7: "Institutional Arrangements   Human resource management   Organizational level: Transparency of human resource planning and allocation process.",
      column8: "Budget, Manage and Implement: Does the organization have the capacity to develop, use and improve competencies of employees?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.6",
      column6: "No",
      column7: "Institutional Arrangements   Human resource management   Organizational level: Use of human resource management plan as a monitoring tool.",
      column8: "Budget, Manage and Implement: Does the organization have the capacity to develop, use and improve competencies of employees?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.6",
      column6: "No",
      column7: "Institutional Arrangements   Human resource management   Organizational level: Use of information technology by employees.",
      column8: "Budget, Manage and Implement: Does the organization have the capacity to develop, use and improve competencies of employees?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.2",
      column6: "No",
      column7: "Institutional Arrangements   Organizational level: Alignment of policy and legal framework with organization‘s mission and priorities; and managerial capacities.",
      column8: "Budget, Manage and Implement: Does the organization have the capacity to develop policies, frameworks and mechanisms that support an integrated approach to budgeting and implementation?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.2",
      column6: "No",
      column7: "Institutional Arrangements   Organizational level: Clarity and awareness of policy and legal framework among organization‘s leaders.",
      column8: "Budget, Manage and Implement: Does the organization have the capacity to develop policies, frameworks and mechanisms that support an integrated approach to budgeting and implementation?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.2",
      column6: "No",
      column7: "Institutional Arrangements   Organizational level: Clarity of the  organization‘s policy and legal framework to domestic and external  stakeholders.",
      column8: "Engage Stakeholders: Does the  organization have the capacity to develop policies, frameworks and  mechanisms that ensure multi   stakeholder participation?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.2",
      column6: "No",
      column7: "Institutional Arrangements   Organizational level: Existence and effectiveness of dialogue mechanisms (and other links as  a appropriate) between the  organization and relevant domestic and external  stakeholders to discuss formulation and implementation of the  organization's policy  and legal framework",
      column8: "Engage Stakeholders: Does the  organization have the capacity to develop policies, frameworks and  mechanisms that ensure multi   stakeholder participation?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.2",
      column6: "No",
      column7: "Institutional Arrangements   Organizational level: Existence of clear  „ rules of the game ‟ and safeguards that establish legitimate policy  processes as leading on policy choice",
      column8: "Assess a Situation and Define Vision and Mandate: Does the  organization have the capacity to frame, manage and interpret a  comprehensive analysis of the policy and legal environment? Does the  organization have the capacity to create a vision for fair and equitable policies, frameworks and  mechanisms?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.2",
      column6: "No",
      column7: "Institutional Arrangements   Organizational level: Existence of evaluation guidelines, procedures, etc.",
      column8: "Evaluate: Does the organization have the capacity to develop policies, frameworks and mechanism for evaluation?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.2",
      column6: "No",
      column7: "Institutional Arrangements   Organizational level: Existence of long   term strategic choices on policy and legal frameworks",
      column8: "Formulate Policies and Strategies: Does the  organization have the capacity to develop policies, frameworks and mechanisms that provide a consistent referent for operations?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.2",
      column6: "No",
      column7: "Institutional Arrangements   Organizational level: Existence of policy and legal framework that is independent, impartial and fair",
      column8: "Formulate Policies and Strategies: Does the  organization have the capacity to develop policies, frameworks and mechanisms that provide a consistent referent for operations?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.2",
      column6: "No",
      column7: "Institutional Arrangements   Organizational level: Extent to which organizational policy and legal framework contributes to achievement of the organization‘s goals and strategies.",
      column8: "Budget, Manage and Implement: Does the organization have the capacity to develop policies, frameworks and mechanisms that support an integrated approach to budgeting and implementation?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.2",
      column6: "No",
      column7: "Institutional Arrangements   Organizational level: Extent to which societal changes are integrated into the  organization's policy and  legal framework",
      column8: "Formulate Policies and Strategies: Does the  organization have the capacity to develop policies, frameworks and mechanisms that provide a consistent referent for operations?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.2",
      column6: "No",
      column7: "Institutional Arrangements   Organizational level: Level of corruption.",
      column8: "Evaluate: Does the organization have the capacity to develop policies, frameworks and mechanism for evaluation?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.2",
      column6: "No",
      column7: "Institutional Arrangements   Organizational level: Quality (e.g., transparent, participatory, engaged, respective) and frequency o f  dialogue between the  organization and domestic and external stakeholders.",
      column8: "Engage Stakeholders: Does the  organization have the capacity to develop policies, frameworks and  mechanisms that ensure multi   stakeholder participation?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.2",
      column6: "No",
      column7: "Institutional Arrangements   Organizational level: Quality of action taken as a result of  'critical events' analysis of opportunities and threats of most significance to the organization‘s policy and legal framework",
      column8: "Assess a Situation and Define Vision and Mandate: Does the  organization have the capacity to frame, manage and interpret a  comprehensive analysis of the policy and legal environment? Does the  organization have the capacity to create a vision for fair and equitable policies, frameworks and  mechanisms?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.2",
      column6: "No",
      column7: "Institutional Arrangements   Organizational level: Quality of analysis of environmental influences (at the appropriate level, e.g.,  market, sector) and their relative degree of impact on the  organization",
      column8: "Assess a Situation and Define Vision and Mandate: Does the  organization have the capacity to frame, manage and interpret a  comprehensive analysis of the policy and legal environment? Does the  organization have the capacity to create a vision for fair and equitable policies, frameworks and  mechanisms?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "3.1",
      column6: "No",
      column7: "Knowledge   Enabling environment: Availability and quality of indicators and benchmarks for outputs, outcomes and impacts of knowledge policies and reforms",
      column8: "Evaluate:\nDo authorities have the necessary capacity to evaluate the outputs, outcomes and impacts of their policies and strategies for knowledge generation and retention?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "3.1",
      column6: "No",
      column7: "Knowledge   Enabling environment: Availability and quality of public information on progress made on knowledge generation and retention at different levels",
      column8: "Evaluate:\nDo authorities have the necessary capacity to evaluate the outputs, outcomes and impacts of their policies and strategies for knowledge generation and retention?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "3.1",
      column6: "No",
      column7: "Knowledge   Enabling environment: Availability and size of the budget envelope for knowledge related policies and programmes.",
      column8: "Budget, Manage and Implement:\nDo authorities have the capacity to mobilize and manage the necessary resources to implement their knowledge policies and strategies?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "3.1",
      column6: "No",
      column7: "Knowledge   Enabling environment: Degree of alignment between the vision for knowledge generation and retention and the authorities‘ overall development vision.",
      column8: "Assess a Situation and Define a Vision and Mandate: Do authorities have the capacity to frame, manage and interpret a comprehensive analysis of the knowledge landscape? \nDo authorities have the capacity to translate the findings of this analysis into a long term, shared, vision for knowledge generation and retention through education, training and learning?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "3.1",
      column6: "No",
      column7: "Knowledge   Enabling environment: Existence and quality of feedback mechanisms between M&E and policies",
      column8: "Evaluate:\nDo authorities have the necessary capacity to evaluate the outputs, outcomes and impacts of their policies and strategies for knowledge generation and retention?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "3.1",
      column6: "No",
      column7: "Knowledge   Enabling environment: Existence and quality of long term, comprehensive policies for education, training and learning.",
      column8: "Formulate Policies and Strategies:\nDo authorities have the capacity to formulate policies and strategies to achieve their vision for knowledge generation and retention?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "3.1",
      column6: "No",
      column7: "Knowledge   Enabling environment: Existence and quality of quick win initiatives for education, training and learning.",
      column8: "Formulate Policies and Strategies:\nDo authorities have the capacity to formulate policies and strategies to achieve their vision for knowledge generation and retention?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "3.1",
      column6: "No",
      column7: "Knowledge   Enabling environment: Existence and use (quality and frequency) of a platform for multi stakeholder engagement on policies and reforms for education, training and learning.",
      column8: "Engage Stakeholders:\nDo authorities have the capacity to engage stakeholders throughout the process of developing and managing policies and reforms for education, learning and training to promote knowledge generation and retention?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "3.1",
      column6: "No",
      column7: "Knowledge   Enabling environment: Existence and use (quality and frequency) of aid coordination mechanisms for education, training and learning.",
      column8: "Engage Stakeholders:\nDo authorities have the capacity to engage stakeholders throughout the process of developing and managing policies and reforms for education, learning and training to promote knowledge generation and retention?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "3.1",
      column6: "No",
      column7: "Knowledge   Enabling environment: Existence of a dedicated Unit for budgetary management and oversight.",
      column8: "Budget, Manage and Implement:\nDo authorities have the capacity to mobilize and manage the necessary resources to implement their knowledge policies and strategies?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "3.1",
      column6: "No",
      column7: "Knowledge   Enabling environment: Existence, quality and use of procedures for identifying quick win initiatives.",
      column8: "Formulate Policies and Strategies:\nDo authorities have the capacity to formulate policies and strategies to achieve their vision for knowledge generation and retention?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "3.1",
      column6: "No",
      column7: "Knowledge   Enabling environment: Extent to which policies and programmes meet their targets within the timeframe adopted.",
      column8: "Budget, Manage and Implement:\nDo authorities have the capacity to mobilize and manage the necessary resources to implement their knowledge policies and strategies?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "3.1",
      column6: "No",
      column7: "Knowledge   Enabling environment: Integrated national local policy and implementation frameworks for knowledge generation and retention.",
      column8: "Engage Stakeholders:\nDo authorities have the capacity to engage stakeholders throughout the process of developing and managing policies and reforms for education, learning and training to promote knowledge generation and retention?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "3.1",
      column6: "No",
      column7: "Knowledge   Enabling environment: Quality of data and analysis on different knowledge generation and retention related indicators.",
      column8: "Assess a Situation and Define a Vision and Mandate: Do authorities have the capacity to frame, manage and interpret a comprehensive analysis of the knowledge landscape? \nDo authorities have the capacity to translate the findings of this analysis into a long term, shared, vision for knowledge generation and retention through education, training and learning?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "3.1",
      column6: "No",
      column7: "Knowledge   Enabling environment: Use and quality of information campaigns no the importance of education, training and learning for knowledge generation and retention.",
      column8: "Engage Stakeholders:\nDo authorities have the capacity to engage stakeholders throughout the process of developing and managing policies and reforms for education, learning and training to promote knowledge generation and retention?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "3.2",
      column6: "No",
      column7: "Knowledge   Organizational level: A mapping of the policies, programmes and activities of other/similar organizations.",
      column8: "Assess a Situation and Define a Vision and Mandate:\nDoes the organization have the capacity to frame, manage and interpret a comprehensive stock taking and analysis of its knowledge and training assets and needs? \nDoes the organization have the capacity to translate the findings of this analysis into a long term, shared, vision for knowledge generation and retention within the organization?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "3.2",
      column6: "No",
      column7: "Knowledge   Organizational level: An organizational vision that recognizes and emphasizes the importance of knowledge and learning.",
      column8: "Assess a Situation and Define a Vision and Mandate:\nDoes the organization have the capacity to frame, manage and interpret a comprehensive stock taking and analysis of its knowledge and training assets and needs? \nDoes the organization have the capacity to translate the findings of this analysis into a long term, shared, vision for knowledge generation and retention within the organization?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "3.2",
      column6: "No",
      column7: "Knowledge   Organizational level: An up to date mapping of the organization‘s knowledge and education capacity assets and needs.",
      column8: "Assess a Situation and Define a Vision and Mandate:\nDoes the organization have the capacity to frame, manage and interpret a comprehensive stock taking and analysis of its knowledge and training assets and needs? \nDoes the organization have the capacity to translate the findings of this analysis into a long term, shared, vision for knowledge generation and retention within the organization?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "3.2",
      column6: "No",
      column7: "Knowledge   Organizational level: Availability and quality (comprehensiveness, frequency of use) of competency assessment frameworks",
      column8: "Evaluate:\nDoes the organization have the capacity to evaluate the outputs and outcomes of its knowledge development/skills strategy?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "3.2",
      column6: "No",
      column7: "Knowledge   Organizational level: Availability and quality of indicators and benchmarks for outputs and outcomes",
      column8: "Evaluate:\nDoes the organization have the capacity to evaluate the outputs and outcomes of its knowledge development/skills strategy?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "3.2",
      column6: "No",
      column7: "Knowledge   Organizational level: Dedicated staff responsible for knowledge/learning/training.",
      column8: "Assess a Situation and Define a Vision and Mandate:\nDoes the organization have the capacity to frame, manage and interpret a comprehensive stock taking and analysis of its knowledge and training assets and needs? \nDoes the organization have the capacity to translate the findings of this analysis into a long term, shared, vision for knowledge generation and retention within the organization?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "3.2",
      column6: "No",
      column7: "Knowledge   Organizational level: Existence and quality (frequency, use) of a space to discuss the organization‘s knowledge priorities and policies for knowledge generation and retention.",
      column8: "Engage Stakeholders:\nDoes the organization have the capacity to engage stakeholders throughout the process of developing and managing policies and reforms for knowledge generation and retention, through education, training and learning?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "3.2",
      column6: "No",
      column7: "Knowledge   Organizational level: Existence and quality of an organizational knowledge/skills development strategy",
      column8: "Formulate Policies and Strategies:\nDoes the organization have the capacity to formulate strategies to achieve their vision for knowledge generation and retention?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "3.2",
      column6: "No",
      column7: "Knowledge   Organizational level: Existence and size of a budget envelope for knowledge/skills development.",
      column8: "Budget, Manage and Implement:\nDoes the organization have the capacity to mobilize and manage the resources needed to implement their knowledge/skills development strategy?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "3.2",
      column6: "No",
      column7: "Knowledge   Organizational level: Extent to which the knowledge/skills development strategy is being implemented within the given timeframe.",
      column8: "Budget, Manage and Implement:\nDoes the organization have the capacity to mobilize and manage the resources needed to implement their knowledge/skills development strategy?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "3.2",
      column6: "No",
      column7: "Knowledge   Organizational level: Partnerships with other organizations in this area.",
      column8: "Budget, Manage and Implement:\nDoes the organization have the capacity to mobilize and manage the resources needed to implement their knowledge/skills development strategy?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "3.2",
      column6: "No",
      column7: "Knowledge   Organizational level: The existence, quality and use of competency profiles.",
      column8: "Assess a Situation and Define a Vision and Mandate:\nDoes the organization have the capacity to frame, manage and interpret a comprehensive stock taking and analysis of its knowledge and training assets and needs? \nDoes the organization have the capacity to translate the findings of this analysis into a long term, shared, vision for knowledge generation and retention within the organization?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "2.1",
      column6: "No",
      column7: "Leadership   Enabling environment: Actionability of objectives and outputs in national and local development work plans.",
      column8: "Budget, Manage and Implement: Do authorities have the capacity to manage implementation of (national or local) plans, strategies, and programmes?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "2.1",
      column6: "No",
      column7: "Leadership   Enabling environment: Alignment of scope of programme or other activities with government‘s mission, priorities and managerial capabilities.",
      column8: "Budget, Manage and Implement: Do authorities have the capacity to manage implementation of (national or local) plans, strategies, and programmes?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "2.1",
      column6: "No",
      column7: "Leadership   Enabling environment: Clarity and awareness of goals and priorities among leaders",
      column8: "Budget, Manage and Implement: Do authorities have the capacity to manage implementation of (national or local) plans, strategies, and programmes?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "2.1",
      column6: "No",
      column7: "Leadership   Enabling environment: Clarity of mission to staff and/or members; documentation of mission.",
      column8: "Assess a Situation and Define Vision and Mandate:\nDo authorities have the capacity to frame, manage and interpret analysis of internal and external dynamics (at the appropriate level, e.g., market, sector)? \nDo authorities have the capacity to conduct long term visioning?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "2.1",
      column6: "No",
      column7: "Leadership   Enabling environment: Degree of delegation of management responsibility.",
      column8: "Budget, Manage and Implement: Do authorities have the capacity to manage implementation of (national or local) plans, strategies, and programmes?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "2.1",
      column6: "No",
      column7: "Leadership   Enabling environment: Degree to which M&E systems and practices yield evidence based foundation for planning, decision making and learning.",
      column8: "Evaluate: Do authorities have the capacity to ensure independent evaluation of medium term target setting, planning and budgeting?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "2.1",
      column6: "No",
      column7: "Leadership   Enabling environment: Depth of management.",
      column8: "Budget, Manage and Implement: Do authorities have the capacity to manage implementation of (national or local) plans, strategies, and programmes?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "2.1",
      column6: "No",
      column7: "Leadership   Enabling environment: Ethics of leaders (e.g., ethical behavior exhibited, number disciplinary cases reported).",
      column8: "Budget, Manage and Implement: Do authorities have the capacity to manage implementation of (national or local) plans, strategies, and programmes?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "2.1",
      column6: "No",
      column7: "Leadership   Enabling environment: Evidence of effective innovation and learning.",
      column8: "Budget, Manage and Implement: Do authorities have the capacity to manage implementation of (national or local) plans, strategies, and programmes?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "2.1",
      column6: "No",
      column7: "Leadership   Enabling environment: Evidence of effective staff involvement and teamwork in planning and work.",
      column8: "Budget, Manage and Implement: Do authorities have the capacity to manage implementation of (national or local) plans, strategies, and programmes?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "2.1",
      column6: "No",
      column7: "Leadership   Enabling environment: Impact on the local, national and international economy and society.",
      column8: "Evaluate: Do authorities have the capacity to ensure independent evaluation of medium term target setting, planning and budgeting?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "2.1",
      column6: "No",
      column7: "Leadership   Enabling environment: Improvement in government management capacity (e.g., number of governmental units displaying improved practices, such as open and transparent financial systems, set organizational procedures, accountability, participatory decision making, by laws and elections).",
      column8: "Evaluate: Do authorities have the capacity to ensure independent evaluation of medium term target setting, planning and budgeting?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "2.1",
      column6: "No",
      column7: "Leadership   Enabling environment: Level of awareness and understanding of program outcomes among government managers.",
      column8: "Evaluate: Do authorities have the capacity to ensure independent evaluation of medium term target setting, planning and budgeting?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "2.1",
      column6: "No",
      column7: "Leadership   Enabling environment: Level of fiscal and operational awareness among leaders (e.g., managers can clearly describe their roles and responsibilities).",
      column8: "Budget, Manage and Implement: Do authorities have the capacity to manage implementation of (national or local) plans, strategies, and programmes?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "2.1",
      column6: "No",
      column7: "Leadership   Enabling environment: Management style (e.g., participatory and enabling).",
      column8: "Budget, Manage and Implement: Do authorities have the capacity to manage implementation of (national or local) plans, strategies, and programmes?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "2.1",
      column6: "No",
      column7: "Leadership   Enabling environment: Measurement of programme outcomes.",
      column8: "Evaluate: Do authorities have the capacity to ensure independent evaluation of medium term target setting, planning and budgeting?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "2.1",
      column6: "No",
      column7: "Leadership   Enabling environment: Nature and quality of planning, decision making and benchmarking processes (e.g., iterative).",
      column8: "Budget, Manage and Implement: Do authorities have the capacity to manage implementation of (national or local) plans, strategies, and programmes?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "2.1",
      column6: "No",
      column7: "Leadership   Enabling environment: Quality of action taken as a result of 'critical events‘ analysis of opportunities and threats of most significance to government‘s development.",
      column8: "Assess a Situation and Define Vision and Mandate:\nDo authorities have the capacity to frame, manage and interpret analysis of internal and external dynamics (at the appropriate level, e.g., market, sector)? \nDo authorities have the capacity to conduct long term visioning?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "2.1",
      column6: "No",
      column7: "Leadership   Enabling environment: Quality of implementation of plans, strategies and programmes (e.g., effective and efficient).",
      column8: "Budget, Manage and Implement: Do authorities have the capacity to manage implementation of (national or local) plans, strategies, and programmes?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "2.1",
      column6: "No",
      column7: "Leadership   Enabling environment: Receptivity of leaders to change and modernization.",
      column8: "Budget, Manage and Implement: Do authorities have the capacity to manage implementation of (national or local) plans, strategies, and programmes?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "2.1",
      column6: "No",
      column7: "Leadership   Enabling environment: Skill level of top management and middle management.",
      column8: "Budget, Manage and Implement: Do authorities have the capacity to manage implementation of (national or local) plans, strategies, and programmes?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "2.1",
      column6: "No",
      column7: "Leadership   Enabling environment: Strength of national organizations (e.g., number of organizations meeting at least xx% of their targeted objectives, improvements, etc.).",
      column8: "Evaluate: Do authorities have the capacity to ensure independent evaluation of medium term target setting, planning and budgeting?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "2.1",
      column6: "No",
      column7: "Leadership   Enabling environment: Strength of programme delivery.",
      column8: "Budget, Manage and Implement: Do authorities have the capacity to manage implementation of (national or local) plans, strategies, and programmes?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "2.2",
      column6: "No",
      column7: "Leadership   Organizational level: Ability of management to effectively represent the organization to external interests.",
      column8: "Engage Stakeholders:\nDoes the organization‘s leadership have the capacity to manage relations with key stakeholders inclusively and constructively?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "2.2",
      column6: "No",
      column7: "Leadership   Organizational level: Actionability of objectives and outputs in organization's work plans.",
      column8: "Budget, Manage and Implement:\nDoes the organization‘s leadership have the capacity to establish appropriate frameworks for managing policies, legislations, strategies, programmes and projects?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "2.2",
      column6: "No",
      column7: "Leadership   Organizational level: Actionability of objectives and outputs of organizational strategies.",
      column8: "Formulate Policies and Strategies:\nDoes the organization‘s leadership have the capacity to translate the vision, mission, value framework into strategic (medium term) and operational (concrete and short term) objectives and actions?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "2.2",
      column6: "No",
      column7: "Leadership   Organizational level: Alignment of organization‘s scope of program or other activities with its mission, priorities and managerial capabilities.",
      column8: "Budget, Manage and Implement:\nDoes the organization‘s leadership have the capacity to establish appropriate frameworks for managing policies, legislations, strategies, programmes and projects?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "2.2",
      column6: "No",
      column7: "Leadership   Organizational level: Clarity of goals and priorities among managers.",
      column8: "Budget, Manage and Implement:\nDoes the organization‘s leadership have the capacity to establish appropriate frameworks for managing policies, legislations, strategies, programmes and projects?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "2.2",
      column6: "No",
      column7: "Leadership   Organizational level: Clarity of leadership philosophy to internal and external stakeholders.",
      column8: "Engage Stakeholders:\nDoes the organization‘s leadership have the capacity to manage relations with key stakeholders inclusively and constructively?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "2.2",
      column6: "No",
      column7: "Leadership   Organizational level: Degree of delegation of management responsibility to second level managers.",
      column8: "Budget, Manage and Implement:\nDoes the organization‘s leadership have the capacity to establish appropriate frameworks for managing policies, legislations, strategies, programmes and projects?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "2.2",
      column6: "No",
      column7: "Leadership   Organizational level: Degree to which M&E systems and practices yield an evidence based foundation for planning, decision making and learning.",
      column8: "Evaluate:\nDoes the organization‘s leadership have the capacity to design, establish and manage a system for measuring financial and operational performance of the organization?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "2.2",
      column6: "No",
      column7: "Leadership   Organizational level: Depth of organizational management.",
      column8: "Budget, Manage and Implement:\nDoes the organization‘s leadership have the capacity to establish appropriate frameworks for managing policies, legislations, strategies, programmes and projects?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "2.2",
      column6: "No",
      column7: "Leadership   Organizational level: Ethics of leaders (e.g., ethical behavior exhibited, number disciplinary cases reported).",
      column8: "Budget, Manage and Implement:\nDoes the organization‘s leadership have the capacity to establish appropriate frameworks for managing policies, legislations, strategies, programmes and projects?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "2.2",
      column6: "No",
      column7: "Leadership   Organizational level: Evidence of bureaucratic support for the organization‘s activities.",
      column8: "Engage Stakeholders:\nDoes the organization‘s leadership have the capacity to manage relations with key stakeholders inclusively and constructively?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "2.2",
      column6: "No",
      column7: "Leadership   Organizational level: Evidence of effective organizational innovation and learning.",
      column8: "Budget, Manage and Implement:\nDoes the organization‘s leadership have the capacity to establish appropriate frameworks for managing policies, legislations, strategies, programmes and projects?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "2.2",
      column6: "No",
      column7: "Leadership   Organizational level: Evidence of effective staff involvement and teamwork in planning and work.",
      column8: "Budget, Manage and Implement:\nDoes the organization‘s leadership have the capacity to establish appropriate frameworks for managing policies, legislations, strategies, programmes and projects?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "2.2",
      column6: "No",
      column7: "Leadership   Organizational level: Existence and effectiveness of dialogue mechanisms (and other links as appropriate) between the organization and relevant domestic and external stakeholders.",
      column8: "Engage Stakeholders:\nDoes the organization‘s leadership have the capacity to manage relations with key stakeholders inclusively and constructively?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "2.2",
      column6: "No",
      column7: "Leadership   Organizational level: Existence of influential and outspoken champions for ownership and capacity development.",
      column8: "Engage Stakeholders:\nDoes the organization‘s leadership have the capacity to manage relations with key stakeholders inclusively and constructively?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "2.2",
      column6: "No",
      column7: "Leadership   Organizational level: Existence of long term strategic policies for capacity development.",
      column8: "Formulate Policies and Strategies:\nDoes the organization‘s leadership have the capacity to translate the vision, mission, value framework into strategic (medium term) and operational (concrete and short term) objectives and actions?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "2.2",
      column6: "No",
      column7: "Leadership   Organizational level: Extent to which societal changes are integrated into organizational functioning.",
      column8: "Formulate Policies and Strategies:\nDoes the organization‘s leadership have the capacity to translate the vision, mission, value framework into strategic (medium term) and operational (concrete and short term) objectives and actions?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "2.2",
      column6: "No",
      column7: "Leadership   Organizational level: External image of the organization (e.g., image is consistent with goals and objectives).",
      column8: "Engage Stakeholders:\nDoes the organization‘s leadership have the capacity to manage relations with key stakeholders inclusively and constructively?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "2.2",
      column6: "No",
      column7: "Leadership   Organizational level: Impact on the local, national and international economy and society.",
      column8: "Evaluate:\nDoes the organization‘s leadership have the capacity to design, establish and manage a system for measuring financial and operational performance of the organization?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "2.2",
      column6: "No",
      column7: "Leadership   Organizational level: Level of autonomy of management.",
      column8: "Budget, Manage and Implement:\nDoes the organization‘s leadership have the capacity to establish appropriate frameworks for managing policies, legislations, strategies, programmes and projects?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "2.2",
      column6: "No",
      column7: "Leadership   Organizational level: Level of awareness and understanding of program outcomes among organizational managers.",
      column8: "Evaluate:\nDoes the organization‘s leadership have the capacity to design, establish and manage a system for measuring financial and operational performance of the organization?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "2.2",
      column6: "No",
      column7: "Leadership   Organizational level: Level of awareness of the impact of the organization on the quality of life of citizens.",
      column8: "Engage Stakeholders:\nDoes the organization‘s leadership have the capacity to manage relations with key stakeholders inclusively and constructively?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "2.2",
      column6: "No",
      column7: "Leadership   Organizational level: Level of fiscal and operational awareness among managers (e.g., staff can clearly describe their roles and responsibilities).",
      column8: "Budget, Manage and Implement:\nDoes the organization‘s leadership have the capacity to establish appropriate frameworks for managing policies, legislations, strategies, programmes and projects?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "2.2",
      column6: "No",
      column7: "Leadership   Organizational level: Level of involvement with the community in which the organization is based through support (financial or otherwise) for local and societal (social, environmental, etc.) activities.",
      column8: "Engage Stakeholders:\nDoes the organization‘s leadership have the capacity to manage relations with key stakeholders inclusively and constructively?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "2.2",
      column6: "No",
      column7: "Leadership   Organizational level: Management style (e.g., participatory and enabling).",
      column8: "Budget, Manage and Implement:\nDoes the organization‘s leadership have the capacity to establish appropriate frameworks for managing policies, legislations, strategies, programmes and projects?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "2.2",
      column6: "No",
      column7: "Leadership   Organizational level: Measurement of programme outcomes.",
      column8: "Evaluate:\nDoes the organization‘s leadership have the capacity to design, establish and manage a system for measuring financial and operational performance of the organization?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "2.2",
      column6: "No",
      column7: "Leadership   Organizational level: Nature and quality of planning, decision making and benchmarking processes (e.g., iterative).",
      column8: "Budget, Manage and Implement:\nDoes the organization‘s leadership have the capacity to establish appropriate frameworks for managing policies, legislations, strategies, programmes and projects?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "2.2",
      column6: "No",
      column7: "Leadership   Organizational level: of mission to employees; documentation of mission.",
      column8: "Assess a Situation and Define Vision and Mandate: Does the organization‘s leadership have the capacity to frame, manage and interpret analysis of internal and external dynamics? \nDoes the organization‘s leadership have the capacity to develop its vision, mission and values based on that analysis?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "2.2",
      column6: "No",
      column7: "Leadership   Organizational level: Organizational ownership of policies, goals and structure.",
      column8: "Engage Stakeholders:\nDoes the organization‘s leadership have the capacity to manage relations with key stakeholders inclusively and constructively?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "2.2",
      column6: "No",
      column7: "Leadership   Organizational level: Quality (e.g., transparent, participatory, engaged, respective) and frequency of dialogue between the organization and domestic and external stakeholders.",
      column8: "Engage Stakeholders:\nDoes the organization‘s leadership have the capacity to manage relations with key stakeholders inclusively and constructively?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "2.2",
      column6: "No",
      column7: "Leadership   Organizational level: Quality of action taken as a result of 'critical events‘ analysis of opportunities and threats of most significance to the organization‘s development and impact.",
      column8: "Assess a Situation and Define Vision and Mandate: Does the organization‘s leadership have the capacity to frame, manage and interpret analysis of internal and external dynamics? \nDoes the organization‘s leadership have the capacity to develop its vision, mission and values based on that analysis?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "2.2",
      column6: "No",
      column7: "Leadership   Organizational level: Quality of analysis of environmental influences (at the appropriate level, e.g., market, sector) and their relative degree of impact on the organization.",
      column8: "Assess a Situation and Define Vision and Mandate: Does the organization‘s leadership have the capacity to frame, manage and interpret analysis of internal and external dynamics? \nDoes the organization‘s leadership have the capacity to develop its vision, mission and values based on that analysis?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "2.2",
      column6: "No",
      column7: "Leadership   Organizational level: Quality of implementation of plans, strategies and programmes (e.g., effective and efficient).",
      column8: "Budget, Manage and Implement:\nDoes the organization‘s leadership have the capacity to establish appropriate frameworks for managing policies, legislations, strategies, programmes and projects?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "2.2",
      column6: "No",
      column7: "Leadership   Organizational level: Receptivity of organization's leaders to change and modernization.",
      column8: "Budget, Manage and Implement:\nDoes the organization‘s leadership have the capacity to establish appropriate frameworks for managing policies, legislations, strategies, programmes and projects?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "2.2",
      column6: "No",
      column7: "Leadership   Organizational level: Skill level of top management and middle management.",
      column8: "Budget, Manage and Implement:\nDoes the organization‘s leadership have the capacity to establish appropriate frameworks for managing policies, legislations, strategies, programmes and projects?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "2.2",
      column6: "No",
      column7: "Leadership   Organizational level: Strength of programme delivery.",
      column8: "Budget, Manage and Implement:\nDoes the organization‘s leadership have the capacity to establish appropriate frameworks for managing policies, legislations, strategies, programmes and projects?"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "2.2",
      column6: "No",
      column7: "Leadership   Organizational level: Strength of the organization (meets at least xx% of its targeted objectives, improvements, etc.).",
      column8: "Evaluate:\nDoes the organization‘s leadership have the capacity to design, establish and manage a system for measuring financial and operational performance of the organization?"
    },
    {
      column1: "GLAAS Country Survey – Long Form, UNICEF and WHO",
      column2: "http://www.who.int/water_sanitation_health/monitoring/investments/glaas 2016 2017 cycle/en/",
      column3: "None found",
      column4: "None",
      column5: "C3",
      column6: "No",
      column7: "Limits to achievement of WASH services",
      column8: "To what extent would the following tasks benefit from increased human resource capacity?  [choices supplied]"
    },
    {
      column1: "UNDP Capacity Assessment Methodology User‘s Guide",
      column2: "http://www.undp.org/content/dam/aplaws/publication/en/publications/capacity development/undp capacity assessment methodology/UNDP%20Capacity%20Assessment%20Users%20Guide.pdf",
      column3: "None found",
      column4: "None",
      column5: "1.3",
      column6: "No",
      column7: "Quality of analysis of environmental influences (Institutional Arrangements   Financial management   Enabling environment: at the appropriate level, e.g., market, sector) and their relative degree of impact on policies relating to financial resource management.",
      column8: "Assess a Situation and Define Vision and Mandate: Do authorities have the capacity to frame, manage and interpret a comprehensive situation analysis of and to create a vision for the country's financial assets as they relate to delivering the MDGs and other international goals and commitments?"
    },
    {
      column1: "UNDG Capacity Assessment Supporting Tool",
      column2: "https://undg.org/main/undg_document/undg capacity assessment methodology/",
      column3: "None Found",
      column4: "None",
      column5: "",
      column6: "No",
      column7: "Public Sector Accountability   Enabling Environment   Situation Assessment",
      column8: "Do authorities have the capacity to develop accountability mechanisms that ensure efficient public service delivery?"
    },
    {
      column1: "UNDG Capacity Assessment Supporting Tool",
      column2: "https://undg.org/main/undg_document/undg capacity assessment methodology/",
      column3: "None Found",
      column4: "None",
      column5: "",
      column6: "No",
      column7: "Public Sector Accountability   Enabling Environment   Policy Design & Strategy Formulation",
      column8: "Do authorities have the capacity to develop and manage accountability mechanisms to ensure formulation of clear and transparent policies and strategies?"
    },
    {
      column1: "UNDG Capacity Assessment Supporting Tool",
      column2: "https://undg.org/main/undg_document/undg capacity assessment methodology/",
      column3: "None Found",
      column4: "None",
      column5: "",
      column6: "No",
      column7: "Public Sector Accountability   Enabling Environment   Resources and Budget Allocation",
      column8: "Do authorities have the capacity to do costing exercises and mobilize resources based on financial implications of PSA accountability strategies and programmes?"
    },
    {
      column1: "UNDG Capacity Assessment Supporting Tool",
      column2: "https://undg.org/main/undg_document/undg capacity assessment methodology/",
      column3: "None Found",
      column4: "None",
      column5: "",
      column6: "No",
      column7: "Public Sector Accountability   Enabling Environment  Programme and Project Implementation",
      column8: "Do authorities have the capacity to implement PSA programmes and projects in collaboration with local bodies and citizen groups’ participation?"
    },
    {
      column1: "UNDG Capacity Assessment Supporting Tool",
      column2: "https://undg.org/main/undg_document/undg capacity assessment methodology/",
      column3: "None Found",
      column4: "None",
      column5: "",
      column6: "No",
      column7: "Public Sector Accountability   Enabling Environment  Monitoring, Evaluation and Learning",
      column8: "Do authorities have the capacity to develop mechanisms for monitoring and evaluation of PSA programmes and policies evaluation?"
    },
    {
      column1: "UNDG Capacity Assessment Supporting Tool",
      column2: "https://undg.org/main/undg_document/undg capacity assessment methodology/",
      column3: "None Found",
      column4: "None",
      column5: "",
      column6: "No",
      column7: "Public Sector Accountability – Organisational Level  Situation Analysis",
      column8: "Does the organisation have the capacity to develop a comprehensive accountability mechanisms based on a through analysis of key accountability issues?"
    },
    {
      column1: "UNDG Capacity Assessment Supporting Tool",
      column2: "https://undg.org/main/undg_document/undg capacity assessment methodology/",
      column3: "None Found",
      column4: "None",
      column5: "",
      column6: "No",
      column7: "Public Sector Accountability   Organisational Level   Policy Design & Strategy Formulation",
      column8: "Does the organisation have the capacity to develop and manage accountability mechanisms to ensure formulation of clear policies and strategies?"
    },
    {
      column1: "UNDG Capacity Assessment Supporting Tool",
      column2: "https://undg.org/main/undg_document/undg capacity assessment methodology/",
      column3: "None Found",
      column4: "None",
      column5: "",
      column6: "No",
      column7: "Public Sector Accountability   Organisational Level   Resources and Budget Allocation",
      column8: "Does the organisation have the capacity to manage accountability mechanisms regarding budget allocation and resource mobilization?"
    },
    {
      column1: "UNDG Capacity Assessment Supporting Tool",
      column2: "https://undg.org/main/undg_document/undg capacity assessment methodology/",
      column3: "None Found",
      column4: "None",
      column5: "",
      column6: "No",
      column7: "Public Sector Accountability   Organisational Level  Programme and Project Implementation",
      column8: "Does the organisation have the capacity to implement and effectively enforce organisation wide accountability mechanisms?"
    },
    {
      column1: "UNDG Capacity Assessment Supporting Tool",
      column2: "https://undg.org/main/undg_document/undg capacity assessment methodology/",
      column3: "None Found",
      column4: "None",
      column5: "",
      column6: "No",
      column7: "Public Sector Accountability   Organisational Level  Monitoring, Evaluation and Learning",
      column8: "Does the organisation have the capacity to develop monitoring and evaluation mechanisms for enforcement of organisational accountability?"
    },
    {
      column1: "UNDG Capacity Assessment Supporting Tool",
      column2: "https://undg.org/main/undg_document/undg capacity assessment methodology/",
      column3: "None Found",
      column4: "None",
      column5: "",
      column6: "No",
      column7: "Access to Information, Development Knowledge and Technology – Enabling Environment   Situation Analysis",
      column8: "Do authorities have the capacity to create a vision for equitable, broad and meaningful access to and provision of information and knowledge and know how?"
    },
    {
      column1: "UNDG Capacity Assessment Supporting Tool",
      column2: "https://undg.org/main/undg_document/undg capacity assessment methodology/",
      column3: "None Found",
      column4: "None",
      column5: "",
      column6: "No",
      column7: "Access to Information, Development Knowledge and Technology – Enabling Environment   Policy Design and Strategy Formulation",
      column8: "Do authorities have the capacity to develop policies and strategies to ensure access to and provision of information and knowledge throughout the development and planning process?"
    },
    {
      column1: "UNDG Capacity Assessment Supporting Tool",
      column2: "https://undg.org/main/undg_document/undg capacity assessment methodology/",
      column3: "None Found",
      column4: "None",
      column5: "",
      column6: "No",
      column7: "Access to Information, Development Knowledge and Technology – Enabling Environment   Resources and Budget Allocation",
      column8: "Do authorities have the capacity to do assess budgeting needs and resource allocations for developing capacity in areas of information management and strategy formulation?"
    },
    {
      column1: "UNDG Capacity Assessment Supporting Tool",
      column2: "https://undg.org/main/undg_document/undg capacity assessment methodology/",
      column3: "None Found",
      column4: "None",
      column5: "",
      column6: "No",
      column7: "Access to Information, Development Knowledge and Technology – Enabling Environment   Programme and Project Implementation",
      column8: "Do authorities have the capacity to implement programmes and projects for improving access to information, technology and development knowledge?"
    },
    {
      column1: "UNDG Capacity Assessment Supporting Tool",
      column2: "https://undg.org/main/undg_document/undg capacity assessment methodology/",
      column3: "None Found",
      column4: "None",
      column5: "",
      column6: "No",
      column7: "Access to Information, Development Knowledge and Technology – Enabling Environment   Monitoring, Evaluation and Learning",
      column8: "Do authorities have the capacity to monitor and evaluate if citizens have easy access to information and knowledge at all levels?"
    },
    {
      column1: "UNDG Capacity Assessment Supporting Tool",
      column2: "https://undg.org/main/undg_document/undg capacity assessment methodology/",
      column3: "None Found",
      column4: "None",
      column5: "",
      column6: "No",
      column7: "Access to Information, Development Knowledge and Technology – Organisational Level   Situation Analysis",
      column8: "Does the organisation have the capacity to assess and analyze knowledge and information gaps at all levels for better targeting of programmes /services?"
    },
    {
      column1: "UNDG Capacity Assessment Supporting Tool",
      column2: "https://undg.org/main/undg_document/undg capacity assessment methodology/",
      column3: "None Found",
      column4: "None",
      column5: "",
      column6: "No",
      column7: "Access to Information, Development Knowledge and Technology – Organisational Level   Policy Design and Strategy Formulation",
      column8: "Does the organisation have the capacity to formulate policies and strategies regarding information, knowledge and technology?"
    },
    {
      column1: "UNDG Capacity Assessment Supporting Tool",
      column2: "https://undg.org/main/undg_document/undg capacity assessment methodology/",
      column3: "None Found",
      column4: "None",
      column5: "",
      column6: "No",
      column7: "Access to Information, Development Knowledge and Technology – Organisational Level   Resources and Budget Allocation",
      column8: "Does the organisation have the capacity to budget programmes to ensure access to and management of information and development knowledge and technology?"
    },
    {
      column1: "UNDG Capacity Assessment Supporting Tool",
      column2: "https://undg.org/main/undg_document/undg capacity assessment methodology/",
      column3: "None Found",
      column4: "None",
      column5: "",
      column6: "No",
      column7: "Access to Information, Development Knowledge and Technology – Organisational Level   Programme/Project Implementation",
      column8: "Does the organisation have the capacity to implement information and technology management programmes and initiatives?"
    },
    {
      column1: "UNDG Capacity Assessment Supporting Tool",
      column2: "https://undg.org/main/undg_document/undg capacity assessment methodology/",
      column3: "None Found",
      column4: "None",
      column5: "",
      column6: "No",
      column7: "Access to Information, Development Knowledge and Technology – Organisational Level   Monitoring, Evaluation and Learning",
      column8: "Does the organisation have the capacity to monitor and evaluate access to and availability of information and development knowledge for its employees and clients?"
    },
    {
      column1: "UNDG Capacity Assessment Supporting Tool",
      column2: "https://undg.org/main/undg_document/undg capacity assessment methodology/",
      column3: "None Found",
      column4: "None",
      column5: "",
      column6: "No",
      column7: "Inclusion, Participation, Equity and Empowerment – Enabling Environment   Situation Analysis",
      column8: "Do authorities have the capacity to enable broad based and meaningful public participation throughout the process of creating national and/or local development plans?"
    },
    {
      column1: "UNDG Capacity Assessment Supporting Tool",
      column2: "https://undg.org/main/undg_document/undg capacity assessment methodology/",
      column3: "None Found",
      column4: "None",
      column5: "",
      column6: "No",
      column7: "Inclusion, Participation, Equity and Empowerment – Enabling Environment  Policy Design and Strategy Formulation",
      column8: "Do authorities have the capacity to ensure decentralization and encourage involvement of civil society, private sector, donors and other development agents throughout the process of developing policies and strategies?"
    },
    {
      column1: "UNDG Capacity Assessment Supporting Tool",
      column2: "https://undg.org/main/undg_document/undg capacity assessment methodology/",
      column3: "None Found",
      column4: "None",
      column5: "",
      column6: "No",
      column7: "Inclusion, Participation, Equity and Empowerment – Enabling Environment   Resources and Budget Allocation",
      column8: "Do authorities have the capacity to ensure public participation in budgeting and management of resources for equitable delivery of services and empowerment of the poor?"
    },
    {
      column1: "UNDG Capacity Assessment Supporting Tool",
      column2: "https://undg.org/main/undg_document/undg capacity assessment methodology/",
      column3: "None Found",
      column4: "None",
      column5: "",
      column6: "No",
      column7: "Inclusion, Participation, Equity and Empowerment – Enabling Environment   Programme and Project Implementation",
      column8: "Do authorities have the capacity to implement and manage programmes, projects and mechanisms to ensure meaningful and systematic participation of the poor and the marginalized groups at all stages of the national planning process?"
    },
    {
      column1: "UNDG Capacity Assessment Supporting Tool",
      column2: "https://undg.org/main/undg_document/undg capacity assessment methodology/",
      column3: "None Found",
      column4: "None",
      column5: "",
      column6: "No",
      column7: "Inclusion, Participation, Equity and Empowerment – Enabling Environment   Monitoring, Evaluation and Learning",
      column8: "Do authorities have the capacity to ensure availability and accessibility of communication and feedback mechanisms in both legislative and executive bodies to ensure citizens concerns are taken into account in policy and programme development and implementation processes?"
    },
    {
      column1: "UNDG Capacity Assessment Supporting Tool",
      column2: "https://undg.org/main/undg_document/undg capacity assessment methodology/",
      column3: "None Found",
      column4: "None",
      column5: "",
      column6: "No",
      column7: "Inclusion, Participation, Equity and Empowerment – Organisational Level   Situation Analysis",
      column8: "Does the organisation have the capacity to undertake a comprehensive situation analysis for promoting a meaningful and broad based participation?"
    },
    {
      column1: "UNDG Capacity Assessment Supporting Tool",
      column2: "https://undg.org/main/undg_document/undg capacity assessment methodology/",
      column3: "None Found",
      column4: "None",
      column5: "",
      column6: "No",
      column7: "Inclusion, Participation, Equity and Empowerment – Organisational Level   Policy Design and Strategy Formulation",
      column8: "Does the organisation have the capacity to develop policies and strategies for promotion of inclusion, participation and empowerment?"
    },
    {
      column1: "UNDG Capacity Assessment Supporting Tool",
      column2: "https://undg.org/main/undg_document/undg capacity assessment methodology/",
      column3: "None Found",
      column4: "None",
      column5: "",
      column6: "No",
      column7: "Inclusion, Participation, Equity and Empowerment – Organisational Level    Resources and Budget Allocation",
      column8: "Does the organisation have the capacity to involve employees and its clientele’s in making budget and resource allocation decisions?"
    },
    {
      column1: "UNDG Capacity Assessment Supporting Tool",
      column2: "https://undg.org/main/undg_document/undg capacity assessment methodology/",
      column3: "None Found",
      column4: "None",
      column5: "",
      column6: "No",
      column7: "Inclusion, Participation, Equity and Empowerment – Organisational Level    Programme and Project Implementation",
      column8: "Does the organisation have the capacity to support implementation arrangements and networks for multi stakeholders engagement and inclusion of marginalized groups?"
    },
    {
      column1: "UNDG Capacity Assessment Supporting Tool",
      column2: "https://undg.org/main/undg_document/undg capacity assessment methodology/",
      column3: "None Found",
      column4: "None",
      column5: "",
      column6: "No",
      column7: "Inclusion, Participation, Equity and Empowerment –Organisational Level    Monitoring, Evaluation and Learning",
      column8: "Does the organisation have the capacity to monitor and evaluate systematically the effectiveness of its policies and programmes on inclusion, participation and empowerment?"
    },
    {
      column1: "UNDG Capacity Assessment Supporting Tool",
      column2: "https://undg.org/main/undg_document/undg capacity assessment methodology/",
      column3: "None Found",
      column4: "None",
      column5: "",
      column6: "No",
      column7: "External / International Relations – Enabling Environment   Situation Analysis",
      column8: "Do the authorities have the capacity to undertake mapping and SWOT analysis of existing economic, knowledge and people to people linkages with key global and regional actors?"
    },
    {
      column1: "UNDG Capacity Assessment Supporting Tool",
      column2: "https://undg.org/main/undg_document/undg capacity assessment methodology/",
      column3: "None Found",
      column4: "None",
      column5: "",
      column6: "No",
      column7: "External / International Relations –  Enabling Environment   Policy Design and Strategy Formulation",
      column8: "Do the authorities have the capacity to design policies and formulate strategies for aligning external partners’ priorities with national priorities?"
    },
    {
      column1: "UNDG Capacity Assessment Supporting Tool",
      column2: "https://undg.org/main/undg_document/undg capacity assessment methodology/",
      column3: "None Found",
      column4: "None",
      column5: "",
      column6: "No",
      column7: "External / International Relations – Enabling Environment   Resources and Budget Allocation",
      column8: "Do the authorities have the capacity to mobilize resources from external sources?"
    },
    {
      column1: "UNDG Capacity Assessment Supporting Tool",
      column2: "https://undg.org/main/undg_document/undg capacity assessment methodology/",
      column3: "None Found",
      column4: "None",
      column5: "",
      column6: "No",
      column7: "External / International Relations –  Enabling Environment   Programme and Project Implementation",
      column8: "Do the authorities have the capacity to implement programmes and projects for aid coordination and better management of external relations?"
    },
    {
      column1: "UNDG Capacity Assessment Supporting Tool",
      column2: "https://undg.org/main/undg_document/undg capacity assessment methodology/",
      column3: "None Found",
      column4: "None",
      column5: "",
      column6: "No",
      column7: "External / International Relations –  Enabling Environment   Monitoring, Evaluation and Learning",
      column8: "Do the authorities have the capacity to monitor and independently evaluate effectiveness of aid coordination and management of debt reduction strategies?"
    },
    {
      column1: "UNDG Capacity Assessment Supporting Tool",
      column2: "https://undg.org/main/undg_document/undg capacity assessment methodology/",
      column3: "None Found",
      column4: "None",
      column5: "",
      column6: "No",
      column7: "External / International Relations – Organsiational Level   Situation Analysis",
      column8: "Does the organisation have the capacity to undertake comprehensive SWOT (strength, weakness, opportunity and threat) analysis for example in areas such as management practices, knowledge and skills, financial and material resources?"
    },
    {
      column1: "UNDG Capacity Assessment Supporting Tool",
      column2: "https://undg.org/main/undg_document/undg capacity assessment methodology/",
      column3: "None Found",
      column4: "None",
      column5: "",
      column6: "No",
      column7: "External / International Relations – Organsiational Level   Policy Design and Strategy Formulation",
      column8: "Does the organisation have the capacity to formulate long term policies and strategies for its growth and development in a globalised and closely linked economies and markets?"
    },
    {
      column1: "UNDG Capacity Assessment Supporting Tool",
      column2: "https://undg.org/main/undg_document/undg capacity assessment methodology/",
      column3: "None Found",
      column4: "None",
      column5: "",
      column6: "No",
      column7: "External / International Relations– Organsiational Level    Resources and Budget Allocation",
      column8: "Does the organisation have the capacity to negotiate external resources and efficiently manage funding from outside?"
    },
    {
      column1: "UNDG Capacity Assessment Supporting Tool",
      column2: "https://undg.org/main/undg_document/undg capacity assessment methodology/",
      column3: "None Found",
      column4: "None",
      column5: "",
      column6: "No",
      column7: "External / International Relations – Organsiational Level   Programme and Project Implementation",
      column8: "Does the organisation have the capacity to implement programmes and projects to facilitate better management of external relations?"
    },
    {
      column1: "UNDG Capacity Assessment Supporting Tool",
      column2: "https://undg.org/main/undg_document/undg capacity assessment methodology/",
      column3: "None Found",
      column4: "None",
      column5: "",
      column6: "No",
      column7: "External / International Relations – Organsiational Level    Monitoring, Evaluation and Learning",
      column8: "Does the organisation have the capacity to monitor and evaluate management of its relations with external partners?"
    },
    {
      column1: "UNDG Capacity Assessment Supporting Tool",
      column2: "https://undg.org/main/undg_document/undg capacity assessment methodology/",
      column3: "None Found",
      column4: "None",
      column5: "",
      column6: "No",
      column7: "Financial Resource Allocation, Management and Oversight –  Enabling Environment   Situation Analysis",
      column8: "Do authorities have the capacity to frame, manage and interpret a comprehensive situation analysis of the country’s financial assets as they relate to achievement of MDGs and other key national goals?"
    },
    {
      column1: "UNDG Capacity Assessment Supporting Tool",
      column2: "https://undg.org/main/undg_document/undg capacity assessment methodology/",
      column3: "None Found",
      column4: "None",
      column5: "",
      column6: "No",
      column7: "Financial Resource Allocation, Management and Oversight – Enabling Environment   Policy Design and Strategy Formulation",
      column8: "Do authorities have the capacity to develop financial policies and plans that support achievement of MDG targets in a cost effective and sustainable manner?"
    },
    {
      column1: "UNDG Capacity Assessment Supporting Tool",
      column2: "https://undg.org/main/undg_document/undg capacity assessment methodology/",
      column3: "None Found",
      column4: "None",
      column5: "",
      column6: "No",
      column7: "Financial Resource Allocation, Management and Oversight –  Enabling Environment   Resources and Budget Allocation",
      column8: "Do authorities have the capacity to manage financial resources, undertake budgetary exercises and mobilize resources for achievement of MDGs?"
    },
    {
      column1: "UNDG Capacity Assessment Supporting Tool",
      column2: "https://undg.org/main/undg_document/undg capacity assessment methodology/",
      column3: "None Found",
      column4: "None",
      column5: "",
      column6: "No",
      column7: "Financial Resource Allocation, Management and Oversight –  Enabling Environment   Programme and Project Implementation",
      column8: "Do authorities have the capacity to develop financial plans and policies to support achievement of the MDGs and other key national priorities?"
    },
    {
      column1: "UNDG Capacity Assessment Supporting Tool",
      column2: "https://undg.org/main/undg_document/undg capacity assessment methodology/",
      column3: "None Found",
      column4: "None",
      column5: "",
      column6: "No",
      column7: "Financial Resource Allocation, Management and Oversight –  Enabling Environment   Monitoring, Evaluation and Learning",
      column8: "Do authorities have the capacity to ensure, through regular monitoring and systematic evaluation, proper use of financial resources?"
    },
    {
      column1: "UNDG Capacity Assessment Supporting Tool",
      column2: "https://undg.org/main/undg_document/undg capacity assessment methodology/",
      column3: "None Found",
      column4: "None",
      column5: "",
      column6: "No",
      column7: "Financial Resource Allocation, Management and Oversight –  Organsiational Level   Situation Analysis",
      column8: "Does the organisation have the capacity to undertake a comprehensive financial analysis and create a future looking plan for financial resource management?"
    },
    {
      column1: "UNDG Capacity Assessment Supporting Tool",
      column2: "https://undg.org/main/undg_document/undg capacity assessment methodology/",
      column3: "None Found",
      column4: "None",
      column5: "",
      column6: "No",
      column7: "Financial Resource Allocation, Management and Oversight –  Organsiational Level   Policy Design and Strategy Formulation",
      column8: "Does the organisation have the capacity to develop long term financial policies and plans?"
    },
    {
      column1: "UNDG Capacity Assessment Supporting Tool",
      column2: "https://undg.org/main/undg_document/undg capacity assessment methodology/",
      column3: "None Found",
      column4: "None",
      column5: "",
      column6: "No",
      column7: "Financial Resource Allocation, Management and Oversight – Organsiational Level    Resources and Budget Allocation",
      column8: "Does the organisation have the capacity to ensure budget allocations are aligned with its long term financial policies and plans?"
    },
    {
      column1: "UNDG Capacity Assessment Supporting Tool",
      column2: "https://undg.org/main/undg_document/undg capacity assessment methodology/",
      column3: "None Found",
      column4: "None",
      column5: "",
      column6: "No",
      column7: "Financial Resource Allocation, Management and Oversight – Organsiational Level   Programme and Project Implementation",
      column8: "Does the organisation have the capacity to enforce financial policies and strategies?"
    },
    {
      column1: "UNDG Capacity Assessment Supporting Tool",
      column2: "https://undg.org/main/undg_document/undg capacity assessment methodology/",
      column3: "None Found",
      column4: "None",
      column5: "",
      column6: "No",
      column7: "Financial Resource Allocation, Management and Oversight – Organsiational Level    Monitoring, Evaluation and Learning",
      column8: "Does the organisation have the capacity to monitor and evaluate efficient and effective use of financial resources?"
    },
    {
      column1: "UNDG Capacity Assessment Supporting Tool",
      column2: "https://undg.org/main/undg_document/undg capacity assessment methodology/",
      column3: "None Found",
      column4: "None",
      column5: "",
      column6: "No",
      column7: "Management and Maintenance of Material Resources –  Enabling Environment   Situation Analysis",
      column8: "Do authorities have the capacity to undertake thorough analysis of infrastructure and material resources in order to design a comprehensive infrastructure development plan that matches MDG based strategies and plans at the national and local levels?"
    },
    {
      column1: "UNDG Capacity Assessment Supporting Tool",
      column2: "https://undg.org/main/undg_document/undg capacity assessment methodology/",
      column3: "None Found",
      column4: "None",
      column5: "",
      column6: "No",
      column7: "Management and Maintenance of Material Resources – Enabling Environment   Policy Design and Strategy Formulation",
      column8: "Do authorities have the capacity to develop policies and strategies relating to management of material resources, infrastructure planning and their regular maintenance?"
    },
    {
      column1: "UNDG Capacity Assessment Supporting Tool",
      column2: "https://undg.org/main/undg_document/undg capacity assessment methodology/",
      column3: "None Found",
      column4: "None",
      column5: "",
      column6: "No",
      column7: "Management and Maintenance of Material Resources – Enabling Environment   Resources and Budget Allocation",
      column8: "Do authorities have the capacity to make budget decisions relating to infrastructure and material resources management participatory and community based?"
    },
    {
      column1: "UNDG Capacity Assessment Supporting Tool",
      column2: "https://undg.org/main/undg_document/undg capacity assessment methodology/",
      column3: "None Found",
      column4: "None",
      column5: "",
      column6: "No",
      column7: "Management and Maintenance of Material Resources –   Enabling Environment   Programme and Project Implementation",
      column8: "Do authorities have the capacity to support community implementation and maintenance of infrastructure and services fostering ownership and sustainability of investments?"
    },
    {
      column1: "UNDG Capacity Assessment Supporting Tool",
      column2: "https://undg.org/main/undg_document/undg capacity assessment methodology/",
      column3: "None Found",
      column4: "None",
      column5: "",
      column6: "No",
      column7: "Management and Maintenance of Material Resources –   Enabling Environment   Monitoring, Evaluation and Learning",
      column8: "Do authorities have the capacity to ensure, through monitoring and evaluation, proper use of infrastructure and material resources?"
    },
    {
      column1: "UNDG Capacity Assessment Supporting Tool",
      column2: "https://undg.org/main/undg_document/undg capacity assessment methodology/",
      column3: "None Found",
      column4: "None",
      column5: "",
      column6: "No",
      column7: "Management and Maintenance of Material Resources – Organsiational Level   Situation Analysis",
      column8: "Does the organisation have the capacity to undertake a comprehensive analysis of its policies, management practices and programmes concerning material and infrastructure resources?"
    },
    {
      column1: "UNDG Capacity Assessment Supporting Tool",
      column2: "https://undg.org/main/undg_document/undg capacity assessment methodology/",
      column3: "None Found",
      column4: "None",
      column5: "",
      column6: "No",
      column7: "Management and Maintenance of Material Resources –  Organsiational Level   Policy Design and Strategy Formulation",
      column8: "Does the organisation have the capacity to develop infrastructure and material resource management policies and plans?"
    },
    {
      column1: "UNDG Capacity Assessment Supporting Tool",
      column2: "https://undg.org/main/undg_document/undg capacity assessment methodology/",
      column3: "None Found",
      column4: "None",
      column5: "",
      column6: "No",
      column7: "Management and Maintenance of Material Resources – Organsiational Level    Resources and Budget Allocation",
      column8: "Does the organisation have the capacity to ensure appropriate budget allocation and necessary resource mobilization for cost efficient implementation of its infrastructure and material resource policies and plans?"
    },
    {
      column1: "UNDG Capacity Assessment Supporting Tool",
      column2: "https://undg.org/main/undg_document/undg capacity assessment methodology/",
      column3: "None Found",
      column4: "None",
      column5: "",
      column6: "No",
      column7: "Management and Maintenance of Material Resources – Organsiational Level   Programme and Project Implementation",
      column8: "Does the organisation have the capacity to manage infrastructure and material resources appropriately in the implementation of programme and projects?"
    },
    {
      column1: "UNDG Capacity Assessment Supporting Tool",
      column2: "https://undg.org/main/undg_document/undg capacity assessment methodology/",
      column3: "None Found",
      column4: "None",
      column5: "",
      column6: "No",
      column7: "Management and Maintenance of Material Resources – Organsiational Level    Monitoring, Evaluation and Learning",
      column8: "Does the organisation have the capacity to monitor and evaluate implementation and management of its material resource and infrastructure programmes and policies?"
    },
    {
      column1: "UNDG Capacity Assessment Supporting Tool",
      column2: "https://undg.org/main/undg_document/undg capacity assessment methodology/",
      column3: "None Found",
      column4: "None",
      column5: "",
      column6: "No",
      column7: "Environmental Resource Management    Enabling Environment   Situation Analysis",
      column8: "Do authorities have the capacity to develop a comprehensive environmental analysis and relate that to national development priorities, particularly in areas of poverty reduction and achievement of MDGs?"
    },
    {
      column1: "UNDG Capacity Assessment Supporting Tool",
      column2: "https://undg.org/main/undg_document/undg capacity assessment methodology/",
      column3: "None Found",
      column4: "None",
      column5: "",
      column6: "No",
      column7: "Environmental Resource Management    Enabling Environment   Policy Design and Strategy Formulation",
      column8: "Do authorities have the capacity to design appropriate policies and strategies relating to environmental resources management?"
    },
    {
      column1: "UNDG Capacity Assessment Supporting Tool",
      column2: "https://undg.org/main/undg_document/undg capacity assessment methodology/",
      column3: "None Found",
      column4: "None",
      column5: "",
      column6: "No",
      column7: "Environmental Resource Management    Enabling Environment   Resources and Budget Allocation",
      column8: "Do authorities have the capacity to make resource allocations and budgeting decisions on environmental management programmes in conjunction with allocations for poverty reduction strategies and MDGs?"
    },
    {
      column1: "UNDG Capacity Assessment Supporting Tool",
      column2: "https://undg.org/main/undg_document/undg capacity assessment methodology/",
      column3: "None Found",
      column4: "None",
      column5: "",
      column6: "No",
      column7: "Environmental Resource Management    Enabling Environment   Programme and Project Implementation",
      column8: "Do authorities have the capacity to implement programmes and projects relating to environmental resource management in a coordinated manner with cross sectoral inputs and in a comprehensive manner?"
    },
    {
      column1: "UNDG Capacity Assessment Supporting Tool",
      column2: "https://undg.org/main/undg_document/undg capacity assessment methodology/",
      column3: "None Found",
      column4: "None",
      column5: "",
      column6: "No",
      column7: "Environmental Resource Management    Enabling Environment   Monitoring, Evaluation and Learning",
      column8: "Do authorities have the capacity to ensure, through monitoring and evaluation, proper use of environmental resources?"
    },
    {
      column1: "UNDG Capacity Assessment Supporting Tool",
      column2: "https://undg.org/main/undg_document/undg capacity assessment methodology/",
      column3: "None Found",
      column4: "None",
      column5: "",
      column6: "No",
      column7: "Environmental Resource Management   Organsiational Level   Situation Analysis",
      column8: "Does the organisation have the capacity to undertake a comprehensive environmental analysis and create a vision for use of environmental resources?"
    },
    {
      column1: "UNDG Capacity Assessment Supporting Tool",
      column2: "https://undg.org/main/undg_document/undg capacity assessment methodology/",
      column3: "None Found",
      column4: "None",
      column5: "",
      column6: "No",
      column7: "Environmental Resource Management   Organsiational Level   Policy Design and Strategy Formulation",
      column8: "Does the organisation have the capacity to develop an environmental resource plan and related strategies?"
    },
    {
      column1: "UNDG Capacity Assessment Supporting Tool",
      column2: "https://undg.org/main/undg_document/undg capacity assessment methodology/",
      column3: "None Found",
      column4: "None",
      column5: "",
      column6: "No",
      column7: "Environmental Resource Management   Organsiational Level    Resources and Budget Allocation",
      column8: "Does the organisation have the capacity allocate budget and resources appropriately to ensure efficient implementation of its environmental resources?"
    },
    {
      column1: "UNDG Capacity Assessment Supporting Tool",
      column2: "https://undg.org/main/undg_document/undg capacity assessment methodology/",
      column3: "None Found",
      column4: "None",
      column5: "",
      column6: "No",
      column7: "Environmental Resource Management    Organsiational Level   Programme and Project Implementation",
      column8: "Does the organisation have the capacity to manage environmental resources properly in programme and project implementation, and ensure effective implementation of its environmental programmes and plans?"
    },
    {
      column1: "UNDG Capacity Assessment Supporting Tool",
      column2: "https://undg.org/main/undg_document/undg capacity assessment methodology/",
      column3: "None Found",
      column4: "None",
      column5: "",
      column6: "No",
      column7: "Environmental Resource Management    Organsiational Level    Monitoring, Evaluation and Learning",
      column8: "Does the organisation have the capacity to monitor and evaluate its use of environmental resources and management of its environmental plans and policies?"
    },
    {
      column1: "UNDG Capacity Assessment Supporting Tool",
      column2: "https://undg.org/main/undg_document/undg capacity assessment methodology/",
      column3: "None Found",
      column4: "None",
      column5: "",
      column6: "No",
      column7: "Human Resources –  Enabling Environment   Situation Analysis",
      column8: "Do authorities have the capacity to frame, manage and interpret comprehensive situation analysis of the country’s human resources assets and needs?"
    },
    {
      column1: "UNDG Capacity Assessment Supporting Tool",
      column2: "https://undg.org/main/undg_document/undg capacity assessment methodology/",
      column3: "None Found",
      column4: "None",
      column5: "",
      column6: "No",
      column7: "Human Resources – Enabling Environment   Policy Design and Strategy Formulation",
      column8: "Do authorities have the capacity to design HRD policies and develop appropriate strategies commensurate with findings of a comprehensive HR capacity assessments and situation analyses?"
    },
    {
      column1: "UNDG Capacity Assessment Supporting Tool",
      column2: "https://undg.org/main/undg_document/undg capacity assessment methodology/",
      column3: "None Found",
      column4: "None",
      column5: "",
      column6: "No",
      column7: "Human Resources –  Enabling Environment   Resources and Budget Allocation",
      column8: "Do authorities have the capacity to manage budgetary processes and resource allocation analysis relating to designing and implementation of comprehensive HR analysis and HR development policies and strategies?"
    },
    {
      column1: "UNDG Capacity Assessment Supporting Tool",
      column2: "https://undg.org/main/undg_document/undg capacity assessment methodology/",
      column3: "None Found",
      column4: "None",
      column5: "",
      column6: "No",
      column7: "Human Resources –  Enabling Environment   Programme and Project Implementation",
      column8: "Do authorities have the capacity to leverage human resources appropriately for cross sector programming and implementation?"
    },
    {
      column1: "UNDG Capacity Assessment Supporting Tool",
      column2: "https://undg.org/main/undg_document/undg capacity assessment methodology/",
      column3: "None Found",
      column4: "None",
      column5: "",
      column6: "No",
      column7: "Human Resources – Enabling Environment   Monitoring, Evaluation and Learning",
      column8: "Do authorities have the capacity to monitor and evaluate performance and trends in HR capacity and productivity enhancement?"
    },
    {
      column1: "UNDG Capacity Assessment Supporting Tool",
      column2: "https://undg.org/main/undg_document/undg capacity assessment methodology/",
      column3: "None Found",
      column4: "None",
      column5: "",
      column6: "No",
      column7: "Human Resources – Organsiational Level   Situation Analysis",
      column8: "Does the organisation have the capacity to frame, manage and interpret a comprehensive analysis of its human resources?"
    },
    {
      column1: "UNDG Capacity Assessment Supporting Tool",
      column2: "https://undg.org/main/undg_document/undg capacity assessment methodology/",
      column3: "None Found",
      column4: "None",
      column5: "",
      column6: "No",
      column7: "Human Resources – Organsiational Level   Policy Design and Strategy Formulation",
      column8: "Does the organisation have the capacity to design human resources policies and develop strategies for development of human resources?"
    },
    {
      column1: "UNDG Capacity Assessment Supporting Tool",
      column2: "https://undg.org/main/undg_document/undg capacity assessment methodology/",
      column3: "None Found",
      column4: "None",
      column5: "",
      column6: "No",
      column7: "Human Resources – Organsiational Level    Resources and Budget Allocation",
      column8: "Does the organisation have the capacity to sustain results of HR developments through appropriate budgetary allocation for training and related activities on a systematic basis?"
    },
    {
      column1: "UNDG Capacity Assessment Supporting Tool",
      column2: "https://undg.org/main/undg_document/undg capacity assessment methodology/",
      column3: "None Found",
      column4: "None",
      column5: "",
      column6: "No",
      column7: "Human Resources –  Organsiational Level   Programme and Project Implementation",
      column8: "Does the organisation have the capacity to implement and manage human resources development programmes and policies?"
    },
    {
      column1: "UNDG Capacity Assessment Supporting Tool",
      column2: "https://undg.org/main/undg_document/undg capacity assessment methodology/",
      column3: "None Found",
      column4: "None",
      column5: "",
      column6: "No",
      column7: "Human Resources – Organsiational Level    Monitoring, Evaluation and Learning",
      column8: "Does the organisation have the capacity to monitor and evaluate HR development policies and programmes implementation in a systematic manner?"
    }
   ];
@Component({
  selector: 'app-capacity-resource',
  templateUrl: './capacity-resource.component.html',
  styleUrls: ['./capacity-resource.component.css']
})
export class CapacityResourceComponent implements OnInit {


//@ViewChild(MatPaginator) paginator: MatPaginator;
@ViewChild(MatSort) sort: MatSort;

  displayedColumns = ['column1', 'column2', 'column3', 'column4', 'column5', 'column6', 'column7', 'column8'];
  dataSource: MatTableDataSource<Element>;

  constructor(private router: Router) {
    this.dataSource = new MatTableDataSource(ELEMENT_DATA);
   }

  ngOnInit() {
    $(".header_active").removeClass("header_active")
    $(".capacity-click").addClass("header_active")
  }

  ngAfterViewInit() {
    //this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }


    addQuestion(){
        this.router.navigateByUrl('/sdg/add-question/'+COMP)
    }
    quesBtnClick(){
        this.router.navigateByUrl('/sdg/capacity-quest')
    }
    dataBtnClick(){
        this.router.navigateByUrl('/sdg/capacity-data')
    }
    reportBtnClick(){
        this.router.navigateByUrl('/sdg/capacity-report')
    }
    homeBtnClick(){
        this.router.navigateByUrl('/sdg/sdg-home')
    }
}



// WEBPACK FOOTER //
// ./src/app/sdg/capacity-resource/capacity-resource.component.ts